/**
 * jk-filter.js — inline-фильтр квартир на карточке ЖК.
 *
 * План jk-smart-filter, блоки 1.2 / 1.7.2 / 1.7.4 (2026-07-28).
 * Разметка: app/templates/pages/jk_content.php (#jkFilter — ЕДИНСТВЕННОЕ
 * содержимое секции #jkFlats с блока 1.7.4). Стили: css/jk-filter.css.
 *
 * Что делает этот файл:
 *   • тянет фасеты ЖК (flat_api.php?action=jk_facets) и рисует управление —
 *     чипы РЕАЛЬНОЙ комнатности, плашки сроков сдачи корпусов, два
 *     двухползунковых слайдера (площадь / цена), счётчик и сортировку;
 *   • держит состояние фильтра и собирает из него запрос выдачи
 *     flat_api.php?action=list в ОДНОМ ИЗ ДВУХ режимов:
 *       view=flats — плоский список квартир ЖК (страницами по 12);
 *       view=plans — карточки планировок ЖК (все одним ответом, без floors[]);
 *   • отдаёт результат подписчикам (window.BroniJkFilter.onResults) —
 *     САМ выдачу НЕ рисует, это jk-filter-results.js.
 *
 * Режим выдачи (блок 1.7.2, дефолт пересмотрен в 1.7.4):
 *   setResultMode('flats'|'plans') — единственный способ его сменить. Режим
 *   входит в `sig` (защита гонки различает режимы), пишется в адрес страницы
 *   (replaceState — ссылку можно переслать) и кэшируется НА КЛИЕНТЕ по режиму:
 *   возврат «Плитка ↔ Планировки» при том же фильтре сети не касается. Смена
 *   любого фильтра меняет подпись — оба кэша протухают сами.
 *   ДЕФОЛТ = 'plans' (`defaultMode`, решение владельца 1.7.4). Поэтому в адресе
 *   молчит `?fv=plans`, а осмысленной «отменяющей» ссылкой стала `?fv=flats`.
 *
 * Контракт для выдачи (window.BroniJkFilter):
 *   onResults(fn)  — fn({mode, flats, floorplans, plans, total, pages, page,
 *                        append, state, sig, catalogUrl}).
 *                    Первый подписчик включает автозагрузку; подписка ПОСЛЕ
 *                    прихода ответа получает последний результат немедленно
 *                    (replay, append:false) — ленивое подключение не «зависает».
 *                    ⛔ `sig` / `catalogUrl` / `state` считаются В МОМЕНТ
 *                    ЗАПРОСА, а не при разборе ответа: пока запрос летит,
 *                    пользователь успевает подвинуть слайдер, и «живые»
 *                    контролы описывали бы уже другой фильтр. `sig` —
 *                    непрозрачная строка: потребитель только СРАВНИВАЕТ её,
 *                    не разбирает (новое поле фильтра попадает в защиту само).
 *   onLoading(fn)  — fn(isLoading)
 *   onError(fn)    — fn(Error). У ошибки есть `stage` ('facets' | 'list'),
 *                    `reason` ('empty' | 'not_found' | 'network' | 'rate_limit' |
 *                    'timeout' | 'bad_payload') и `retryable`.
 *   onFacets(fn)   — fn(facets | null). null = ТЕРМИНАЛЬНО нечего показывать
 *                    (скрытый ЖК / нет квартир / фасеты не поднялись). Подписка
 *                    после факта получает ответ сразу — «грузим» и «нечего»
 *                    всегда различимы.
 *   apply(opts)    — {page, append} перезапрос
 *   loadMore()     — следующая страница с append=true (в режиме plans — null:
 *                    планировки приходят одним ответом, страниц у них нет)
 *   fetchPlanFlats({rooms, areaMin, areaMax}) — квартиры ОДНОЙ планировки
 *                    (раскрытие карточки, блок 1.7.3). Promise:
 *                      • {flats, total, catalogUrl, cached} — показывать.
 *                        ⛔ `flats` обрезаны страницей (100), `total` — сколько
 *                        их на самом деле: на проде есть кластеры по 337 квартир,
 *                        и «показали 100 из 337» обязано быть видно, иначе
 *                        237 квартир недостижимы. `catalogUrl` — тот же набор
 *                        фильтров в полном каталоге;
 *                      • null — ответ УСТАРЕЛ (фильтр сменился, пока запрос
 *                        летел, либо запрос вытеснен кликом по другой карточке);
 *                      • reject(Error со stage:'plan') — сбой, показать в
 *                        аккордеоне (общий #jkFilterError фильтр НЕ трогает:
 *                        основная выдача на экране цела).
 *   cancelPlanFlats() — оборвать летящее раскрытие (панель закрыли)
 *   currentSig()   — подпись фильтра по ЖИВЫМ контролам. Непрозрачна: её только
 *                    СРАВНИВАЮТ с `payload.sig` уже нарисованного набора, чтобы
 *                    понять «карточки на экране всё ещё описывают текущий
 *                    фильтр?» (окно debounce, пока запрос ещё не ушёл).
 *   setResultMode(mode, opts) — 'flats' | 'plans'; true, если режим сменился.
 *                    `{writeUrl:false}` — не трогать адрес (восстановление вида
 *                    из памяти браузера не должно менять ссылку на страницу).
 *   setRooms(n)    — комнатность извне (0 = студия, null = «Все»); значения вне
 *                    фасетов ЖК игнорируются, вернёт false. Ведёт себя как клик
 *                    по чипу. Легаси-якоря `#room-r2` идут своим путём —
 *                    внутренним primeRooms(), до первого запроса.
 *   setPrice(min,max) / setFloor(min,max) — диапазон извне (версия 6). Ведут
 *                    себя как ручной ввод в поля «от-до»: значение ВИДНО на
 *                    слайдере и в полях, запрос уходит тем же debounce. null =
 *                    граница дома. Вырожденный (скрытый) диапазон не трогают и
 *                    возвращают false. Значения зажимаются в границы фасетов.
 *   setDeadline(label) — срок сдачи извне (версия 6) ПО ПОДПИСИ плашки, а НЕ по
 *                    индексу: набор и порядок сроков у каждого ЖК свои, и
 *                    запомненный индекс отфильтровал бы по чужому сроку. null =
 *                    «Любой». Вернёт false, если такой плашки нет или сроки у
 *                    ЖК не выбираются (sections_supported=false).
 *   setRenovation(key) — отделка извне (версия 7) ПО КЛЮЧУ БАКЕТА
 *                    ('none'|'rough'|'whitebox'|'fine'), а НЕ по индексу и НЕ по
 *                    подписи. Ключи — серверный whitelist RenovationBucket, он
 *                    один на все витрины и стабилен; подпись же меняется вместе
 *                    с текстом кнопки, а индекс зависит от того, какие бакеты
 *                    вообще есть у ЭТОГО ЖК. null = «Любая». Вернёт false, если
 *                    такого бакета у ЖК нет.
 *   drive(query, sort) — ТОЛЬКО во вкладке «Планировки» витрины квартир дома
 *                    (`data-on-showcase`, версия 8): фильтр блока берёт набор фильтров
 *                    витрины целиком (те же имена параметров, что у flat_api.php), свои
 *                    контролы не читает. true — набор сменился и выдача перезапрошена.
 *   version        — версия контракта (8). Потребитель, которому нужны сеттеры
 *                    цены/этажа/срока/отделки, обязан проверять
 *                    `typeof api.setPrice`, а не число: у человека в браузере
 *                    может лежать старый закэшированный jk-filter.js.
 *   resultMode     — текущий режим выдачи
 *   defaultMode    — SSOT дефолтного режима ('plans' с 1.7.4). Вид выдачи обязан
 *                    брать стартовое состояние отсюда, а не хранить свою копию.
 *   urlMode        — режим, ЯВНО заданный ссылкой, или null (адрес главнее памяти)
 *   reset()        — сброс к дефолту
 *   getState()     — КОПИЯ снимка состояния
 *   getQuery()     — применённые фильтры плоским объектом
 *   catalogUrl()   — URL flats.php с building_id + текущими фильтрами
 *   facets / lastResult — КОПИИ (мутация снаружи не портит внутреннее состояние)
 *   facetsState    — 'idle' | 'loading' | 'ready' | 'empty' | 'error'
 *   buildingId / city / resultsEl
 *
 * Правила проекта: IIFE + guard, никаких inline-обработчиков (CSP),
 * fetch с credentials:'same-origin', тексты из API — только textContent.
 */
(() => {
    'use strict';

    const root = document.getElementById('jkFilter');
    if (!root) return; // не на карточке ЖК

    const buildingId = parseInt(root.getAttribute('data-building-id') || '0', 10) || 0;
    if (buildingId <= 0) return;

    const city = String(root.getAttribute('data-city') || '');

    /**
     * ⛔ ВКЛАДКА «ПЛАНИРОВКИ» ВИТРИНЫ КВАРТИР ДОМА (27.09.2026). Блок приходит туда куском
     * `?part=plans` (public/flats.php, js/flats-plans-view.js) с меткой `data-on-showcase`.
     * Фильтр у витрины СВОЙ — комнатность, цена, «Ещё фильтры», сортировка над сеткой, корпус
     * с генплана, — и второй в блоке был бы тем самым «двумя фильтрами» (слово владельца).
     * Поэтому здесь фильтр блока ВЕДОМЫЙ: набор фильтров приходит от витрины (`drive`), свои
     * контролы (они на экран не выводятся) в запрос не идут, адрес страницы (`?fv=`) не
     * пишется и не читается — вид витрины живёт в её собственном `?view=`.
     */
    const ON_SHOWCASE = root.hasAttribute('data-on-showcase');
    // Имена параметров фильтра витрины, которые понимает выдача ЖК (flat_api.php, action=list):
    // тот же набор, что витрина шлёт за плиткой, — поэтому «Найдено» у вкладок одно.
    const DRIVE_KEYS = ['rooms', 'rooms_min', 'price_min', 'price_max', 'area_min', 'area_max',
        'floor_min', 'floor_max', 'deadline', 'discount', 'renovation', 'installment', 'kind',
        'sections', 'section_numbers'];

    // ═══ Константы ═══
    const API_URL = '/flat_api.php';
    // Слайдер за один drag даёт десятки input-событий: без окна ожидания это
    // десятки запросов и гарантированный 429 (ведро выдачи ЖК — 120/60).
    const DEBOUNCE_MS = 320;
    // Чипы и сортировка ощущаются мгновенными, но серия быстрых кликов
    // («1-комн» → «2-комн» → «3-комн») не должна улетать тремя запросами.
    const CHIP_DEBOUNCE_MS = 120;
    const PER_PAGE = 12;
    const DEFAULT_SORT = 'price_asc';
    const SORTS = ['price_asc', 'price_desc', 'area_desc', 'area_asc'];
    // Режимы выдачи = значения параметра view= у flat_api.php?action=list.
    const RESULT_MODES = ['flats', 'plans'];
    /**
     * SSOT вида выдачи по умолчанию (блок 1.7.4, решение владельца).
     *
     * 'plans' — секция «Квартиры» открывается ПЛАНИРОВКАМИ: у ЖК на 6.5k лотов
     * список отдельных квартир нечитаем, а планировок ~70, и раскрытие даёт
     * квартиры нужного типа в один клик.
     *
     * Отсюда же следует смысл параметра адреса: `?fv=plans` теперь молчалив (это
     * и есть дефолт), а `?fv=flats` — ОСМЫСЛЕННАЯ отменяющая ссылка «покажи
     * список квартир». Обе стороны читает readModeFromUrl и уважает
     * js/jk-filter-results.js.
     *
     * Значение отдаётся наружу (`defaultMode` в контракте): вид выдачи не имеет
     * права заводить собственный дефолт — иначе первый запрос уходил бы за одним
     * набором данных, а экран показывал другой.
     *
     * ⛔ Дефолт СЛЕДУЕТ за флагом отката. При `$jkFlatsLegacyCards` (шаблон отдаёт
     * его в `data-legacy-cards`) под фильтром снова живёт старая механика с теми
     * же планировками — стартовать планировками значило бы показать человеку два
     * одинаковых списка подряд. Откат обязан возвращать поведение ДО 1.7.4, а там
     * фильтр открывался квартирами.
     */
    const LEGACY_CARDS = root.getAttribute('data-legacy-cards') === '1';
    const DEFAULT_MODE = LEGACY_CARDS ? 'flats' : 'plans';
    // Короткое имя в адресе страницы: «filter view». Длинное `view` заняли бы у
    // самой страницы ЖК, а фильтр не единственный её потребитель.
    const MODE_PARAM = 'fv';
    const AREA_STEP = 0.1;
    const PRICE_STEP = 50000;
    // Этаж — целое число, дробного шага у него быть не может (1.7.8).
    const FLOOR_STEP = 1;
    // Одна отложенная попытка по сетевому сбою фасетов: без неё моргнувший
    // wi-fi убивает фильтр на всю сессию.
    const FACETS_RETRY_MS = 1200;
    // 429 — не ошибка данных, а «подожди»; ретраим один раз чуть позже.
    const RATE_RETRY_MS = 4000;
    // Висящий fetch без ответа: без таймаута спиннер живёт вечно.
    const REQUEST_TIMEOUT_MS = 12000;
    // Единственные ключи, которые плашка срока имеет право положить в запрос.
    // Иначе битый/подменённый фасет мог бы переопределить action/building_id.
    const FACET_QUERY_KEYS = ['sections', 'deadline'];
    // Ключи бакетов отделки — зеркало серверного whitelist RenovationBucket
    // (app/lib/Domain/RealEstate/RenovationBucket.php). Значение вне этого списка
    // сервер всё равно отбросит (isValid), но мы и не отправляем его: тогда
    // «фильтр применён» и «фильтр сработал» не разъезжаются.
    const RENOVATION_KEYS = ['none', 'rough', 'whitebox', 'fine'];
    // ── Раскрытие квартир планировки (блок 1.7.3) ──
    // Одна страница на всю планировку: сервер и так режет per_page до 100, а
    // кластер из сотни квартир — уже аномалия фида, а не витрина.
    const PLAN_PER_PAGE = 100;
    /**
     * Полуширина расширения диапазона площади планировки, м².
     *
     * Границы кластера (`area_min`..`area_max`) приезжают числами JSON и уходят
     * обратно в фильтр строкой — на этом пути площадь вроде 42.2 может стать
     * 42.19999999999999, и квартира РОВНО на границе выпала бы из своей же
     * планировки. Микродопуск лечит это гарантированно.
     *
     * Почему НЕ FloorplanGrouper::TOLERANCE_M2 (0.5): соседний кластер начинается
     * СРАЗУ за границей допуска, а `map_flats`.`area` — `decimal(6,1)`, то есть
     * площади различаются шагом 0.1 м² и зазор между кластерами ≥ 0.1 м².
     * Расширение на 0.5 затянуло бы в аккордеон квартиры ЧУЖОЙ планировки —
     * ровно те дубли, ради схлопывания которых группировка и живёт. Годится
     * любое значение строго меньше половины зазора (0.05); 0.005 — с запасом.
     */
    const AREA_EPS = 0.005;
    // Потолок клиентского кэша раскрытий: у ЖК бывает под две сотни планировок,
    // и по 100 квартир в каждой — это уже мегабайты в памяти вкладки.
    const PLAN_CACHE_MAX = 40;

    // ═══ DOM ═══
    const byId = id => document.getElementById(id);
    const dom = {
        roomsGroup: byId('jkFilterRoomsGroup'),
        rooms: byId('jkFilterRooms'),
        deadlinesGroup: byId('jkFilterDeadlinesGroup'),
        deadlines: byId('jkFilterDeadlines'),
        ranges: byId('jkFilterRanges'),
        found: byId('jkFilterFound'),
        sort: byId('jkFilterSort'),
        reset: byId('jkFilterReset'),
        results: byId('jkFilterResults'),
        error: byId('jkFilterError'),
        sectionsGroup: byId('jkFilterSectionsGroup'),
        sections: byId('jkFilterSections'),
    };
    if (!dom.rooms || !dom.deadlines || !dom.found) return;

    /**
     * Группа чипов «Отделка» (владелец 18.08.2026) собирается ЗДЕСЬ, а не в
     * шаблоне: разметка у неё ровно та же, что у комнатности и сроков (классы
     * `jk-filter__group` / `__label` / `__chips` уже стилизованы в jk-filter.css),
     * поэтому отдельный узел в jk_content.php ничего бы не добавил, а изменение
     * шаблона тронуло бы файл, который сейчас правят по другой задаче.
     *
     * Группа встаёт СРАЗУ ЗА СРОКАМИ — перед слайдерами: чипы это выбор из
     * готовых вариантов, слайдеры — ввод чисел, и мешать их местами значит
     * рвать ритм панели. Не нашлось якоря (разметку переписали) — фильтр
     * работает без отделки, а не падает целиком.
     */
    (() => {
        const anchor = dom.deadlinesGroup;
        if (!anchor || !anchor.parentNode) return;
        const group = document.createElement('div');
        group.className = 'jk-filter__group jk-hidden';
        group.id = 'jkFilterRenovationGroup';
        const label = document.createElement('span');
        label.className = 'jk-filter__label';
        label.id = 'jkFilterRenovationLabel';
        label.textContent = 'Отделка';
        const chips = document.createElement('div');
        chips.className = 'jk-filter__chips';
        chips.id = 'jkFilterRenovation';
        chips.setAttribute('role', 'group');
        chips.setAttribute('aria-labelledby', 'jkFilterRenovationLabel');
        group.appendChild(label);
        group.appendChild(chips);
        anchor.parentNode.insertBefore(group, anchor.nextSibling);
        dom.renovationGroup = group;
        dom.renovation = chips;
    })();

    // ═══ Утилиты ═══
    const clamp = (v, lo, hi) => Math.min(Math.max(v, lo), hi);
    const isNum = v => typeof v === 'number' && isFinite(v);
    const clone = v => {
        if (v === null || typeof v !== 'object') return v;
        try {
            return typeof structuredClone === 'function'
                ? structuredClone(v)
                : JSON.parse(JSON.stringify(v));
        } catch (e) {
            return JSON.parse(JSON.stringify(v));
        }
    };

    const groupDigits = s => String(s).replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0');
    const fmtPrice = v => groupDigits(Math.round(v));
    const fmtArea = v => {
        const r = Math.round(v * 10) / 10;
        return (Number.isInteger(r) ? String(r) : r.toFixed(1)).replace('.', ',');
    };
    // Этаж — целое без разрядных пробелов: «12», а не «12,0» и не «1 2».
    const fmtFloor = v => String(Math.round(v));
    const parseUserNumber = raw => {
        const cleaned = String(raw == null ? '' : raw)
            .replace(/[\s\u00A0\u202F]/g, '')
            .replace(',', '.')
            .replace(/[^\d.]/g, '');
        const v = parseFloat(cleaned);
        return isFinite(v) ? v : null;
    };
    const pluralRu = (n, one, few, many) => {
        const abs = Math.abs(n) % 100;
        const tail = abs % 10;
        if (abs > 10 && abs < 20) return many;
        if (tail > 1 && tail < 5) return few;
        return tail === 1 ? one : many;
    };
    const roundStep = (v, step) => Math.round(v / step) * step;

    /** Ошибка с машиночитаемой причиной — 1.3 отличает «нечего» от «сломалось». */
    const filterError = (message, stage, reason, retryable) => {
        const err = new Error(message);
        err.stage = stage;
        err.reason = reason;
        err.retryable = retryable === true;
        return err;
    };

    // ═══ Режим выдачи в адресе страницы ═══
    /**
     * Режим из ссылки. Адрес важнее локального «запомнили прошлый вид»: человек
     * прислал ссылку на планировки — она обязана открыться планировками, каким
     * бы ни был вид, сохранённый в этом браузере.
     */
    function readModeFromUrl() {
        const m = new RegExp('(?:^|[?&])' + MODE_PARAM + '=([^&#]*)').exec(window.location.search);
        // БЕЗ decodeURIComponent: имена режимов — ASCII-whitelist, декодировать
        // нечего, а на битом проценте («?fv=%» / «?fv=%zz») decodeURIComponent
        // кидает URIError — он убил бы весь IIFE, и одна такая ссылка выключала
        // бы фильтр вместе с выдачей целиком (fix-round-5 P1).
        const raw = m ? m[1] : '';
        return RESULT_MODES.indexOf(raw) >= 0 ? raw : null;
    }

    /**
     * Легаси-якорь секции квартир: `#room-studio` / `#room-r1`…`#room-r5`.
     *
     * Так раскрывалась группа комнатности в снесённом аккордеоне (1.7.4). Ссылки
     * с этими якорями живут во внешнем индексе и в закладках, и вести они обязаны
     * туда же по смыслу — в фильтр с выбранной комнатностью, а не «в никуда»
     * (несуществующий id = браузер просто остаётся наверху страницы).
     *
     * `r5` у аккордеона означал «5 и более» (Math.min(5, rooms)); фасеты отдают
     * точные значения, поэтому 5 матчится только при наличии пятикомнатных —
     * иначе якорь игнорируется, и человек видит обычную выдачу вместо пустой.
     */
    // `^…$` без флага `m` в JS якорит ВСЮ строку (в отличие от PCRE, где нужен
    // `\A…\z`): «#room-r2evil» не пройдёт.
    const ROOM_ANCHOR_RE = /^#room-(studio|r([1-5]))$/;

    function readRoomAnchor() {
        const m = ROOM_ANCHOR_RE.exec(String(window.location.hash || ''));
        if (!m) return null;
        return m[2] ? parseInt(m[2], 10) : 0;
    }

    /**
     * ADR-125: приказ сервера о комнатности на странице группы внутри ЖК.
     *
     * Приходит из `window.BRONI_JK_ROOMS_PINNED` — того же объекта, который
     * `public/flats.php` печатает для витрины. Ровно два вида, и они РАЗНЫЕ:
     *
     *   • `{rooms: N}`      — группа значит РОВНО N комнат (студии, 1-3);
     *   • `{rooms_min: N}`  — группа значит N И БОЛЬШЕ (верхняя, `4-komnatnye`).
     *
     * ⛔ ВЕРХНЮЮ ГРУППУ НЕЛЬЗЯ ВЫРАЗИТЬ ЧИПОМ. Фасеты отдают ТОЧНЫЕ значения
     * (см. шапку легаси-якоря выше), поэтому `rooms=4` выбросил бы из выдачи
     * пятикомнатные — они остались бы в счётчике заголовка и в карте сайта,
     * но исчезли бы со страницы, которая их обещает. Поэтому нижняя граница
     * едет отдельным параметром `rooms_min` в КАЖДОМ запросе выдачи, а чип
     * при этом не нажат: человек видит «Все» — и это правда, все квартиры
     * ЭТОЙ страницы.
     *
     * @returns {{rooms: ?number, roomsMin: ?number}}
     */
    function readRoomsPin() {
        const pin = window.BRONI_JK_ROOMS_PINNED;
        const empty = { rooms: null, roomsMin: null };
        if (!pin || typeof pin !== 'object') return empty;
        const exact = parseInt(pin.rooms, 10);
        const floor = parseInt(pin.rooms_min, 10);
        return {
            rooms: Number.isInteger(exact) && exact >= 0 ? exact : null,
            roomsMin: Number.isInteger(floor) && floor > 0 ? floor : null,
        };
    }

    /**
     * Якорь отработал — убираем его из адреса (replaceState, без записи в
     * историю). Иначе F5 или возврат «назад» снова принудительно выставляли бы
     * комнатность поверх того, что человек уже выбрал руками.
     */
    function forgetRoomAnchor() {
        const h = window.history;
        if (!h || typeof h.replaceState !== 'function') return;
        try {
            h.replaceState(h.state, '', window.location.pathname + window.location.search);
        } catch (e) {
            // Песочница без прав на history — якорь просто останется в адресе.
        }
    }

    /**
     * Пишем режим в адрес БЕЗ новой записи истории (replaceState): переключатель
     * вида — не «шаг назад», кнопка «Назад» обязана уводить со страницы ЖК, а не
     * отматывать клики по видам.
     *
     * Пары query-строки переписываются как есть (кроме своей): пересборка через
     * URLSearchParams превратила бы %20 в «+» в чужих параметрах — тот же
     * капкан, из-за которого фильтр не использует URLSearchParams в запросах.
     */
    function syncUrl() {
        // Витрина: вид и фильтр в адресе пишет она сама (js/flats.js).
        if (ON_SHOWCASE) return;
        const h = window.history;
        if (!h || typeof h.replaceState !== 'function') return;
        const raw = String(window.location.search || '').replace(/^\?/, '');
        const keep = raw === '' ? [] : raw.split('&').filter(
            pair => pair !== '' && pair.indexOf(MODE_PARAM + '=') !== 0
        );
        if (state.mode !== DEFAULT_MODE) keep.push(MODE_PARAM + '=' + encodeURIComponent(state.mode));
        const search = keep.length > 0 ? '?' + keep.join('&') : '';
        try {
            h.replaceState(h.state, '', window.location.pathname + search + window.location.hash);
        } catch (e) {
            // iframe/песочница без прав на history — режим всё равно работает,
            // просто ссылка на него не пересылается.
        }
    }

    // ═══ Состояние ═══
    const state = {
        rooms: null,        // int | null («Все»)
        deadlineIdx: null,  // индекс плашки в facets.deadlines | null
        // Имя корпуса (секции) как его отдаёт сервер, либо null («Любой»).
        // ⛔ Именно ИМЯ, а не индекс: набор корпусов у каждого ЖК свой,
        // и индекс «3» означал бы разные дома у разных ЖК.
        section: null,
        sectionNumbers: '',
        // Ключ бакета отделки ('none'|'rough'|'whitebox'|'fine') | null.
        // ⛔ Именно КЛЮЧ, а не индекс чипа: набор бакетов у каждого ЖК свой, и
        // индекс «1» означал бы «Черновая» у одного дома и «Предчистовая» у
        // другого — та же мина, из-за которой срок сдачи ходит подписью.
        renovation: null,
        areaMin: null,
        areaMax: null,
        priceMin: null,
        priceMax: null,
        floorMin: null,
        floorMax: null,
        sort: DEFAULT_SORT,
        mode: DEFAULT_MODE,
        page: 1,
    };

    // Режим, ЯВНО заданный ссылкой (или null). Отдаётся наружу: потребитель вида
    // обязан знать, что адрес приказал режим, и не перебивать его своей памятью
    // (localStorage). Считается ОДИН раз на старте — потом адрес пишем мы сами.
    const urlMode = ON_SHOWCASE ? null : readModeFromUrl();
    if (urlMode !== null) state.mode = urlMode;

    /** Набор фильтров витрины → только известные выдаче ключи, значения строками. */
    function cleanDrive(query) {
        const q = {};
        if (!query || typeof query !== 'object') return q;
        DRIVE_KEYS.forEach(k => {
            const v = query[k];
            if (typeof v === 'string' ? v !== '' : (typeof v === 'number' && isFinite(v))) q[k] = String(v);
        });
        return q;
    }
    // Стартовый набор кладёт вкладка атрибутом ДО загрузки этого файла: первый запрос
    // выдачи уходит сразу с фильтрами витрины, а не «весь дом» с перезапросом следом.
    let driven = null;
    if (ON_SHOWCASE) {
        let start = null;
        try {
            start = JSON.parse(root.getAttribute('data-flats-drive') || 'null');
        } catch (e) {
            start = null;
        }
        driven = cleanDrive(start && start.query);
        state.mode = 'plans';
        if (start && SORTS.indexOf(start.sort) >= 0) state.sort = start.sort;
    }

    // Комнатность из легаси-якоря секции квартир. Применяется в applyFacets —
    // раньше нельзя: пока фасеты не приехали, неизвестно, есть ли такие квартиры
    // у этого ЖК вообще.
    //
    // ⛔ ADR-125 (28.08.2026): НА СТРАНИЦЕ ГРУППЫ КОМНАТНОСТЬ ПРИКАЗЫВАЕТ СЕРВЕР, а не
    // адресная строка. Адрес там ЧПУ-шный (`…/kvartiry/2-komnatnye/`), хвоста `#room-r2`
    // в нём нет и быть не должно, а query nginx стирает хвостовым `?`. Без серверной
    // переменной фильтр на такой странице стартовал бы со «Все» — заголовок обещал бы
    // двухкомнатные, а список показывал весь дом.
    const roomsPin = readRoomsPin();
    // ⛔ ПРИКАЗ СЕРВЕРА ЕДЕТ В ЗАПРОС ПРЯМО ИЗ roomsPin (см. getQuery), А НЕ ЧЕРЕЗ ЧИП.
    // Раньше точная группа шла путём легаси-якоря (primeRooms), но на странице группы
    // свой чип заблокирован и в реестр чипов НЕ входит — primeRooms() его не находил,
    // комнатность в запрос не попадала, и страница «2-комнатные» показывала весь дом
    // под своим заголовком (поймано 28.08.2026 тестом связки фильтр → выдача).
    let roomAnchor = roomsPinned() || ON_SHOWCASE ? null : readRoomAnchor();

    let facets = null;
    let facetsState = 'idle';
    let facetsInflight = false;
    let facetsRetryPending = false;
    let lastResult = null;
    // Последняя выдача КАЖДОГО режима под подписью её фильтра. Переключение
    // «Плитка ↔ Планировки» при том же фильтре берётся отсюда, без сети.
    // Подпись включает режим и весь набор фильтров: сменили фильтр — ни одна
    // запись больше не совпадёт, протухание бесплатное.
    const modeCache = { flats: null, plans: null };
    let inflight = null;      // AbortController активного запроса
    let inflightMode = null;  // режим этого запроса — защита от серии кликов по виду
    // Раскрытые планировки: ключ = подпись фильтра + комнатность/диапазон
    // площади. Смена фильтра меняет подпись — записи протухают сами, чистить
    // нечего. Отдельный AbortController: раскрытие не должно обрывать выдачу.
    const planCache = new Map();
    let planInflight = null;
    let debounceTimer = null;
    let rateRetryTimer = null;
    let autoLoad = false;     // true после первого onResults-подписчика
    let lastFailedReq = null; // {page, append} последнего НЕ доехавшего запроса

    const listeners = { results: [], loading: [], error: [], facets: [] };
    const emit = (kind, payload) => {
        listeners[kind].slice().forEach(fn => {
            try {
                fn(payload);
            } catch (e) {
                console.warn('jk-filter listener error:', e && e.message);
            }
        });
    };

    // ═══ Диапазон: два input[type=range] + два текстовых поля ═══
    function createRange(cfg) {
        const box = byId(cfg.boxId);
        const minEl = byId(cfg.minId);
        const maxEl = byId(cfg.maxId);
        const minNum = byId(cfg.minNumId);
        const maxNum = byId(cfg.maxNumId);
        const fill = byId(cfg.fillId);
        if (!box || !minEl || !maxEl || !minNum || !maxNum || !fill) return null;

        const bounds = { lo: 0, hi: 0 };
        let degenerate = true;

        const paint = () => {
            const span = bounds.hi - bounds.lo;
            const from = parseFloat(minEl.value);
            const to = parseFloat(maxEl.value);
            const p1 = span > 0 ? ((from - bounds.lo) / span) * 100 : 0;
            const p2 = span > 0 ? ((to - bounds.lo) / span) * 100 : 100;
            fill.style.left = p1 + '%';
            fill.style.width = Math.max(0, p2 - p1) + '%';
        };

        const paintNums = () => {
            minNum.value = cfg.format(parseFloat(minEl.value));
            maxNum.value = cfg.format(parseFloat(maxEl.value));
        };

        // Бегунки не должны перепрыгивать друг друга: «от» упирается в «до».
        const clampPair = movedMax => {
            const from = parseFloat(minEl.value);
            const to = parseFloat(maxEl.value);
            if (from > to) {
                if (movedMax) {
                    minEl.value = String(to);
                } else {
                    maxEl.value = String(from);
                }
            }
        };

        /**
         * Границы приходят СЫРЫМИ. Вырожденный диапазон (у ЖК одна квартира —
         * min === max) прячем целиком: слайдер с придуманным «max = min + шаг»
         * обещал бы выбор, которого нет, и первый же сдвиг давал бы пустую выдачу.
         */
        const setBounds = (lo, hi) => {
            degenerate = !(hi > lo);
            box.classList.toggle('jk-hidden', degenerate);
            const safeHi = degenerate ? lo + cfg.step : hi;
            bounds.lo = lo;
            bounds.hi = safeHi;
            [minEl, maxEl].forEach(el => {
                el.min = String(lo);
                el.max = String(safeHi);
                el.step = String(cfg.step);
                el.disabled = degenerate;
            });
            minEl.value = String(lo);
            maxEl.value = String(safeHi);
            paint();
            paintNums();
        };

        const isDefault = () =>
            degenerate ||
            (parseFloat(minEl.value) <= bounds.lo && parseFloat(maxEl.value) >= bounds.hi);

        const value = () => {
            if (isDefault()) return { min: null, max: null };
            return { min: parseFloat(minEl.value), max: parseFloat(maxEl.value) };
        };

        const resetToBounds = () => {
            minEl.value = String(bounds.lo);
            maxEl.value = String(bounds.hi);
            paint();
            paintNums();
        };

        /**
         * Выставить диапазон ИЗВНЕ (публичные setPrice/setFloor, версия 6).
         *
         * Ведёт себя как ручной ввод в поля: значения зажимаются в границы
         * фасетов и округляются к шагу — то есть выставить «до 4,3 млн» у дома,
         * где дешевле 5 млн ничего нет, нельзя: получится нижняя граница дома.
         * ⛔ ЗАПРОС ОТСЮДА НЕ УХОДИТ. Его планирует ВЫЗЫВАЮЩИЙ (setPrice ниже)
         *    одним общим onControlChange — иначе три сеттера подряд дали бы три
         *    расписания вместо одного (debounce их схлопнет, но полагаться на
         *    случайность порядка нельзя).
         * ⛔ ВЫРОЖДЕННЫЙ ДИАПАЗОН НЕ ТРОГАЕМ. Он спрятан от человека целиком, и
         *    записать в него значение значило бы фильтровать по контролу,
         *    которого на экране нет.
         *
         * @param {?number} lo нижняя граница (null = граница дома)
         * @param {?number} hi верхняя граница (null = граница дома)
         * @returns {boolean} изменилось ли значение
         */
        const setValues = (lo, hi) => {
            if (degenerate) return false;
            const fit = (v, fallback) => (isNum(v)
                ? clamp(roundStep(v, cfg.step), bounds.lo, bounds.hi)
                : fallback);
            let from = fit(lo, bounds.lo);
            let to = fit(hi, bounds.hi);
            // «от» выше «до» — меняем местами, как commitNum: пара 12…8
            // означает 8…12, а подтягивание превратило бы её в точку.
            if (from > to) {
                const tmp = from;
                from = to;
                to = tmp;
            }
            if (String(from) === minEl.value && String(to) === maxEl.value) return false;
            minEl.value = String(from);
            maxEl.value = String(to);
            paint();
            paintNums();
            return true;
        };

        const onSlide = movedMax => {
            clampPair(movedMax);
            paint();
            paintNums();
            cfg.onChange();
        };

        minEl.addEventListener('input', () => onSlide(false));
        maxEl.addEventListener('input', () => onSlide(true));

        // Текстовое поле — источник правды только после подтверждения
        // (change/Enter), иначе «2» в середине набора «2500000» дёргало бы запрос.
        // Если человек ввёл «от» больше «до» — МЕНЯЕМ значения местами, а не
        // тянем второй бегунок следом: «от 12 млн» в поле «до 8 млн» означает
        // «8-12», а подтягивание превращало диапазон в точку и давало пусто.
        const commitNum = (numEl, isMax) => {
            const parsed = parseUserNumber(numEl.value);
            const fallback = isMax ? bounds.hi : bounds.lo;
            const next = clamp(
                roundStep(parsed == null ? fallback : parsed, cfg.step),
                bounds.lo,
                bounds.hi
            );
            const other = parseFloat((isMax ? minEl : maxEl).value);
            const crossed = isMax ? next < other : next > other;
            if (crossed) {
                minEl.value = String(isMax ? next : other);
                maxEl.value = String(isMax ? other : next);
            } else {
                (isMax ? maxEl : minEl).value = String(next);
            }
            paint();
            paintNums();
            cfg.onChange();
        };

        [[minNum, false], [maxNum, true]].forEach(pair => {
            const numEl = pair[0];
            const isMax = pair[1];
            numEl.addEventListener('change', () => commitNum(numEl, isMax));
            numEl.addEventListener('keydown', e => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    commitNum(numEl, isMax);
                }
            });
        });

        return {
            setBounds, value, isDefault, setValues,
            reset: resetToBounds, isDegenerate: () => degenerate,
        };
    }

    const areaRange = createRange({
        boxId: 'jkFilterAreaBox',
        minId: 'jkFilterAreaMin',
        maxId: 'jkFilterAreaMax',
        minNumId: 'jkFilterAreaMinNum',
        maxNumId: 'jkFilterAreaMaxNum',
        fillId: 'jkFilterAreaFill',
        step: AREA_STEP,
        format: fmtArea,
        onChange: () => onControlChange(DEBOUNCE_MS),
    });

    const priceRange = createRange({
        boxId: 'jkFilterPriceBox',
        minId: 'jkFilterPriceMin',
        maxId: 'jkFilterPriceMax',
        minNumId: 'jkFilterPriceMinNum',
        maxNumId: 'jkFilterPriceMaxNum',
        fillId: 'jkFilterPriceFill',
        step: PRICE_STEP,
        format: fmtPrice,
        onChange: () => onControlChange(DEBOUNCE_MS),
    });

    /**
     * Этаж «от–до» (1.7.8). Тот же createRange, что у площади и цены: границы
     * приезжают в фасетах (`floor`), вырожденный диапазон (одноэтажный ЖК или
     * этаж вообще неизвестен) прячется целиком — как у остальных двух.
     */
    const floorRange = createRange({
        boxId: 'jkFilterFloorBox',
        minId: 'jkFilterFloorMin',
        maxId: 'jkFilterFloorMax',
        minNumId: 'jkFilterFloorMinNum',
        maxNumId: 'jkFilterFloorMaxNum',
        fillId: 'jkFilterFloorFill',
        step: FLOOR_STEP,
        format: fmtFloor,
        onChange: () => onControlChange(DEBOUNCE_MS),
    });

    // ═══ Сбор состояния и запроса ═══
    function syncStateFromControls() {
        const a = areaRange ? areaRange.value() : { min: null, max: null };
        const p = priceRange ? priceRange.value() : { min: null, max: null };
        const f = floorRange ? floorRange.value() : { min: null, max: null };
        state.areaMin = a.min;
        state.areaMax = a.max;
        state.priceMin = p.min;
        state.priceMax = p.max;
        state.floorMin = f.min;
        state.floorMax = f.max;
    }

    /** Применённые фильтры плоским объектом (без служебных page/per_page). */
    function getQuery() {
        // Витрина: только её набор фильтров, копией (потребитель не портит внутренний).
        if (ON_SHOWCASE) return Object.assign({}, driven || {});
        syncStateFromControls();
        const q = {};
        // ⛔ ADR-125: НИЖНЯЯ ГРАНИЦА ГРУППЫ — В КАЖДЫЙ ЗАПРОС, И ПЕРВОЙ СТРОКОЙ.
        // На странице `…/kvartiry/4-komnatnye/` она означает «четыре и больше», и без
        // неё любой сброс фильтра («Все») вернул бы человеку весь дом под заголовком
        // «Купить 4-комнатную квартиру». Ручной выбор чипа её не отменяет и не может:
        // `rooms=5` вместе с `rooms_min=4` — это по-прежнему подмножество страницы.
        if (roomsPin.roomsMin !== null) q.rooms_min = String(roomsPin.roomsMin);
        // ТОЧНАЯ группа («2-комнатные») — тем же путём и с тем же приоритетом: она
        // приказ сервера, а не выбор человека, и не зависит от того, нашёлся ли чип.
        // Чип своей группы на такой странице заблокирован, чужие — ссылки, поэтому
        // state.rooms там всегда null; но и внешний setRooms() приказ не перебьёт.
        if (roomsPin.rooms !== null) q.rooms = String(roomsPin.rooms);
        else if (state.rooms !== null) q.rooms = String(state.rooms);
        if (isNum(state.priceMin)) q.price_min = String(Math.round(state.priceMin));
        if (isNum(state.priceMax)) q.price_max = String(Math.round(state.priceMax));
        if (isNum(state.areaMin)) q.area_min = String(state.areaMin);
        if (isNum(state.areaMax)) q.area_max = String(state.areaMax);
        // Этаж — целые: API кладёт их в WHERE как int, дробь была бы мусором.
        // Имена параметров те же, что у полного каталога (flats.php их читает),
        // поэтому ссылка «Открыть в полном каталоге» переносит этаж как есть.
        if (isNum(state.floorMin)) q.floor_min = String(Math.round(state.floorMin));
        if (isNum(state.floorMax)) q.floor_max = String(Math.round(state.floorMax));
        // Отделка — ключ бакета, тот же параметр `renovation`, что читает полный
        // каталог (flats.php) и flat_api.php: ссылка «Открыть в полном каталоге»
        // переносит выбор как есть.
        if (state.renovation !== null) q.renovation = state.renovation;


        // Плашка срока несёт ГОТОВЫЙ query-объект ({sections:"Литер 1|Литер 2"}
        // или {deadline:"..."}) — кладём его as-is. Собирать фильтр из подписи
        // нельзя: подпись это текст для человека, а не значение фильтра.
        // Ключи — по белому списку: битый фасет не должен переопределять
        // action/building_id/per_page (defense-in-depth, значения всё равно чужие).
        // Корпус — отдельным выбором. ⛔ Ставится ПОСЛЕ плашки срока: если человек
        // выбрал и срок, и корпус, побеждает корпус — он точнее, а плашка срока
        // несёт целый список секций этого срока.
        const facet = pickDeadlineFacet();
        if (facet && facet.query) {
            FACET_QUERY_KEYS.forEach(k => {
                const v = facet.query[k];
                if (typeof v === 'string' && v !== '') q[k] = v;
            });
        }
        if (state.section) {
            q.sections = state.section;
            if (state.sectionNumbers) q.section_numbers = state.sectionNumbers;
        }
        return q;
    }

    function pickDeadlineFacet() {
        if (state.deadlineIdx === null || !facets || !Array.isArray(facets.deadlines)) return null;
        return facets.deadlines[state.deadlineIdx] || null;
    }

    /**
     * Сборка query-строки. Именно encodeURIComponent, а не URLSearchParams:
     * имена корпусов — кириллица с пробелами, склеенные «|» (JkFilterFacets::
     * SECTIONS_DELIMITER). Form-urlencoded кодирует пробел как «+», и любой
     * промежуточный слой, который прочитает параметр как путь, а не как форму,
     * вернёт «Литер+1» — корпуса с таким именем нет. %20 читается однозначно.
     */
    function qs(pairs) {
        const out = [];
        pairs.forEach(pair => {
            out.push(encodeURIComponent(pair[0]) + '=' + encodeURIComponent(pair[1]));
        });
        return out.join('&');
    }

    function queryPairs(q) {
        return Object.keys(q).map(k => [k, q[k]]);
    }

    /**
     * Строка запроса выдачи. В режиме plans страниц НЕТ — карточки планировок
     * приходят одним ответом, поэтому page/per_page не отправляем вовсе: они
     * обещали бы серверу пагинацию, которой в этом виде не существует.
     */
    function buildListUrl(page, q) {
        const pairs = [
            ['action', 'list'],
            ['view', state.mode],
            ['building_id', String(buildingId)],
        ]
            .concat(queryPairs(q))
            .concat([['sort', state.sort]]);
        if (state.mode !== 'plans') {
            pairs.push(['page', String(page)]);
            pairs.push(['per_page', String(PER_PAGE)]);
        }
        return API_URL + '?' + qs(pairs);
    }

    /**
     * Непрозрачная подпись НАБОРА ФИЛЬТРОВ (без страницы). Нужна блоку 1.3,
     * чтобы отличить «вторую страницу того же фильтра» от отставшего ответа
     * прежнего фильтра. Собирается из ВСЕГО q автоматически — перечислять поля
     * руками нельзя: новое поле фильтра тихо выпало бы из защиты.
     */
    function requestSig(q) {
        const parts = Object.keys(q).sort().map(k => k + '=' + q[k]);
        // Режим — часть подписи: без него отставший ответ «квартир» подменил бы
        // собой уже нарисованные планировки (набор фильтров у них тот же).
        // Служебный префикс — как у сортировки: он не может встретиться в
        // именах фильтров, значит «view» из фильтра с ним не столкнётся.
        parts.push(' view=' + state.mode);
        parts.push(' sort=' + state.sort);
        return parts.join('&');
    }

    /** URL полного каталога для КОНКРЕТНОГО набора фильтров. */
    function catalogUrlFor(q) {
        const head = city !== '' ? [['city', city]] : [];
        const pairs = head
            .concat([['building_id', String(buildingId)]])
            .concat(queryPairs(q))
            .concat([['sort', state.sort]]);
        return '/flats.php?' + qs(pairs);
    }

    /** Публичный catalogUrl() — по текущему состоянию контролов. */
    function catalogUrl() {
        return catalogUrlFor(getQuery());
    }

    // ═══ Загрузка выдачи ═══
    function onControlChange(delayMs) {
        syncCountVisibility();
        schedule(delayMs);
    }

    function schedule(delayMs) {
        if (debounceTimer) {
            clearTimeout(debounceTimer);
            debounceTimer = null;
        }
        state.page = 1;
        debounceTimer = setTimeout(() => {
            debounceTimer = null;
            apply({ page: 1 });
        }, delayMs);
    }

    /**
     * Ответ API → payload подписчиков. Оба режима отдают ОДИН И ТОТ ЖЕ набор
     * ключей (пустые массивы вместо отсутствующих) — потребитель не гадает,
     * какие поля есть, а смотрит на `mode`.
     *
     * `d.view !== mode` = сервер не понял режим (например, у пользователя ещё
     * старый кэш фронта против нового бэка или наоборот). Молча показать пустой
     * список нельзя — это выглядело бы как «в ЖК нет планировок».
     */
    function buildPayload(d, req) {
        const isPlans = req.mode === 'plans';
        if (isPlans && d.view !== 'plans') {
            throw filterError('view mismatch', 'list', 'bad_payload', false);
        }
        return {
            mode: req.mode,
            flats: !isPlans && Array.isArray(d.flats) ? d.flats : [],
            floorplans: isPlans && Array.isArray(d.floorplans) ? d.floorplans : [],
            plans: isPlans ? (parseInt(d.plans, 10) || 0) : 0,
            total: parseInt(d.total, 10) || 0,
            // У планировок страниц нет: весь набор приходит одним ответом.
            pages: isPlans ? 1 : (parseInt(d.pages, 10) || 0),
            page: isPlans ? 1 : (parseInt(d.page, 10) || req.page),
            append: req.append === true,
            state: req.state,
            sig: req.sig,
            catalogUrl: req.catalogUrl,
        };
    }

    /**
     * Кладём выдачу в кэш режима. Дописанная страница НАКАПЛИВАЕТСЯ: вернувшись
     * из «Планировок» в «Плитку», человек обязан увидеть всё, что успел
     * долистать, а не первые 12 квартир.
     */
    function cacheStore(payload) {
        const entry = modeCache[payload.mode];
        if (payload.append === true && entry && entry.sig === payload.sig) {
            entry.payload.flats = entry.payload.flats.concat(payload.flats);
            entry.payload.page = payload.page;
            entry.payload.pages = payload.pages;
            entry.payload.total = payload.total;
            return;
        }
        modeCache[payload.mode] = { sig: payload.sig, payload: clone(payload) };
    }

    /** Кэш режима, если он описывает ИМЕННО текущий набор фильтров. */
    function cacheHit(mode) {
        const entry = modeCache[mode];
        if (!entry) return null;
        return entry.sig === requestSig(getQuery()) ? entry : null;
    }

    function emitCached(entry) {
        const payload = clone(entry.payload);
        // Замена набора, а не дописывание: выдача перерисовывается целиком.
        payload.append = false;
        payload.cached = true;
        lastResult = payload;
        setCounter(payload.total, payload.mode === 'plans' ? payload.plans : null);
        emit('results', payload);
        return payload;
    }

    /**
     * Смена режима выдачи (квартиры ↔ планировки). Возвращает true, если режим
     * действительно изменился. Данные того же фильтра берутся из кэша — сеть
     * дёргается только за режимом, которого ещё не видели.
     *
     * @param {string} mode 'flats' | 'plans'
     * @param {{writeUrl?: boolean}} [opts] `writeUrl:false` — НЕ трогать адрес
     *        страницы. Нужно при восстановлении вида из памяти браузера: иначе
     *        у человека, once выбравшего планировки, КАЖДАЯ карточка ЖК получала
     *        бы `?fv=plans` в адресе, и он расходился бы с присланными ссылками.
     */
    function setResultMode(mode, opts) {
        if (RESULT_MODES.indexOf(mode) < 0 || mode === state.mode) return false;
        state.mode = mode;
        state.page = 1;
        if (!opts || opts.writeUrl !== false) syncUrl();
        clearRateRetry();
        lastFailedReq = null;
        if (debounceTimer) {
            clearTimeout(debounceTimer);
            debounceTimer = null;
        }
        showError('');
        if (!autoLoad) return true;
        const cached = cacheHit(mode);
        if (cached) {
            emitCached(cached);
            return true;
        }
        // Запрос ИМЕННО этого режима уже летит (серия кликов «Плитка ↔ Планировки»
        // быстрее ответа) — ждём его. Иначе каждый второй клик = полный SQL-проход
        // по квартирам ЖК, а переключатель вида — единственный контрол без debounce.
        // На ветке кэша выше мы чужой запрос НЕ обрываем специально: он доедет и
        // ляжет в кэш (см. apply), и обратный клик тоже станет мгновенным.
        if (inflight && inflightMode === mode) return true;
        apply({ page: 1 });
        return true;
    }

    function apply(opts) {
        const o = opts || {};
        const page = Math.max(1, parseInt(o.page, 10) || 1);
        const append = o.append === true;
        state.page = page;
        clearRateRetry();
        lastFailedReq = null;

        // Слепок ЗАПРОСА. Всё, что описывает «какой это был фильтр», считаем
        // здесь и кладём в ответ как есть. Разбирать живые контролы в момент
        // ответа нельзя: за время полёта запроса пользователь успевает
        // подвинуть слайдер, и выдача приписалась бы к чужому фильтру.
        const query = getQuery();
        const reqSig = requestSig(query);
        const reqCatalogUrl = catalogUrlFor(query);
        const reqState = snapshot();
        // Режим тоже фиксируем: пока ответ летит, человек может переключить вид,
        // и разбор ответа по ЖИВОМУ режиму приписал бы квартиры планировкам.
        const reqMode = state.mode;

        // Предыдущий запрос больше не нужен: пользователь уже сдвинул слайдер
        // дальше. Без abort ответы приходят вразнобой и «Найдено N» мигает
        // цифрой от устаревшего фильтра.
        if (inflight) inflight.abort();
        const ctrl = new AbortController();
        ctrl.timedOut = false;
        inflight = ctrl;
        inflightMode = reqMode;
        root.classList.add('is-loading');
        emit('loading', true);
        showError('');

        // Зависший запрос без таймаута держит спиннер вечно: обрываем сами и
        // помечаем обрыв как СВОЙ, чтобы не спутать с вытеснением новым фильтром.
        const timeoutId = setTimeout(() => {
            ctrl.timedOut = true;
            ctrl.abort();
        }, REQUEST_TIMEOUT_MS);

        return fetch(buildListUrl(page, query), {
            credentials: 'same-origin',
            signal: ctrl.signal,
        })
            .then(r => {
                if (r.status === 429) {
                    throw filterError('rate limit', 'list', 'rate_limit', true);
                }
                if (!r.ok) {
                    throw filterError('HTTP ' + r.status, 'list', 'network', r.status >= 500);
                }
                return r.json();
            })
            .then(d => {
                if (ctrl.signal.aborted) return null;
                if (!d || d.ok !== true) {
                    throw filterError('bad payload', 'list', 'bad_payload', false);
                }
                const payload = buildPayload(d, {
                    mode: reqMode, page: page, append: append,
                    state: reqState, sig: reqSig, catalogUrl: reqCatalogUrl,
                });
                cacheStore(payload);
                // Режим переключили, пока ответ летел. Данные не выбрасываем —
                // они уже в кэше своего режима и сделают обратный клик мгновенным,
                // но экран и счётчик принадлежат уже ДРУГОМУ режиму.
                if (payload.mode !== state.mode) return payload;
                lastResult = payload;
                setCounter(payload.total, payload.mode === 'plans' ? payload.plans : null);
                emit('results', payload);
                return payload;
            })
            .catch(e => {
                if (e && e.name === 'AbortError' && !ctrl.timedOut) return null;
                const err = ctrl.timedOut
                    ? filterError('timeout', 'list', 'timeout', true)
                    : (e && e.stage ? e : filterError(e && e.message, 'list', 'network', true));
                handleListError(err, page, append);
                return null;
            })
            .finally(() => {
                clearTimeout(timeoutId);
                if (inflight === ctrl) {
                    inflight = null;
                    inflightMode = null;
                    root.classList.remove('is-loading');
                    emit('loading', false);
                }
            });
    }

    /**
     * Повтор ИМЕННО того запроса, который не доехал — вместе с флагом append.
     * Без этого «Повторить» после сбоя «Показать ещё» слал бы страницу как
     * append:false и стирал уже показанные квартиры (ловил e2e-верификатор).
     * Кнопка «Повторить» и автоповтор 429 идут одним путём.
     */
    function retryFailed() {
        const req = lastFailedReq || { page: state.page, append: false };
        clearRateRetry();
        return apply({ page: req.page, append: req.append });
    }

    function handleListError(err, page, append) {
        console.warn('jk-filter load error:', err.reason, err.message);
        setCounter(null);
        lastFailedReq = { page: page, append: append };
        if (err.reason === 'rate_limit') {
            showError('Слишком много запросов — подождите пару секунд.', true);
            // Один автоповтор: пользователь ничего не делал «не так», ведро
            // просто переполнилось серией его же кликов.
            rateRetryTimer = setTimeout(() => {
                rateRetryTimer = null;
                retryFailed();
            }, RATE_RETRY_MS);
        } else if (err.reason === 'timeout') {
            showError('Сервер долго не отвечает. Попробуйте ещё раз.', true);
        } else {
            showError('Не удалось загрузить квартиры. Попробуйте ещё раз.', true);
        }
        emit('error', err);
    }

    function clearRateRetry() {
        if (rateRetryTimer) {
            clearTimeout(rateRetryTimer);
            rateRetryTimer = null;
        }
    }

    function loadMore() {
        // Планировки приходят одним ответом — «следующей страницы» не бывает.
        if (state.mode === 'plans') return null;
        if (!lastResult || lastResult.page >= lastResult.pages) return null;
        return apply({ page: lastResult.page + 1, append: true });
    }

    // ═══ Квартиры одной планировки — раскрытие карточки (блок 1.7.3) ═══

    /**
     * Отбор карточки планировки → числа. Идентичность планировки — ИМЕННО
     * комнатность + диапазон площадей: `plan_id` порядковый внутри ответа и
     * между запросами съезжает, по нему раскрытие ловило бы чужие квартиры.
     *
     * @returns {?{rooms: number, lo: number, hi: number}} null — мусор на входе.
     */
    function normPlanSel(sel) {
        const rooms = parseInt(sel && sel.rooms, 10);
        const lo = parseFloat(sel && sel.areaMin);
        const hi = parseFloat(sel && sel.areaMax);
        if (!Number.isInteger(rooms) || rooms < 0) return null;
        if (!isFinite(lo) || lo <= 0 || !isFinite(hi) || hi < lo) return null;
        return { rooms: rooms, lo: lo, hi: hi };
    }

    /**
     * Граница планировки, суженная уже применённым фильтром площади. Карточка
     * могла остаться от ПРЕЖНЕГО фильтра (человек двинул слайдер и, не дождавшись
     * новой выдачи, кликнул по старой карточке) — раскрытие обязано остаться
     * внутри того, что человек выбрал сейчас.
     */
    const tighten = (planEdge, filterEdge, pick) => {
        const f = parseFloat(filterEdge);
        return isFinite(f) ? pick(planEdge, f) : planEdge;
    };

    /**
     * Набор фильтров раскрытия: ВСЕ текущие фильтры человека + комнатность и
     * диапазон площади карточки. Из него собираются И запрос к API, И ссылка на
     * полный каталог — чтобы «показать все» вело ровно в тот набор, который
     * панель показала частично.
     */
    function planQuery(base, sel) {
        const q = {};
        Object.keys(base).forEach(k => { q[k] = base[k]; });
        q.rooms = String(sel.rooms);
        q.area_min = tighten(sel.lo - AREA_EPS, base.area_min, Math.max).toFixed(3);
        q.area_max = tighten(sel.hi + AREA_EPS, base.area_max, Math.min).toFixed(3);
        return q;
    }

    /**
     * `view=flats` здесь описывает ЗАПРОС, а не вид выдачи: на экране в этот
     * момент планировки.
     */
    function planListUrl(q) {
        const pairs = [
            ['action', 'list'],
            ['view', 'flats'],
            ['building_id', String(buildingId)],
        ]
            .concat(queryPairs(q))
            .concat([
                ['sort', state.sort],
                ['page', '1'],
                ['per_page', String(PLAN_PER_PAGE)],
            ]);
        return API_URL + '?' + qs(pairs);
    }

    function planCacheStore(key, entry) {
        // Простое FIFO: Map отдаёт ключи в порядке вставки, поэтому «первый
        // ключ» — самое давнее раскрытие. LRU тут не нужен: после смены фильтра
        // прежние записи становятся НЕДОСТИЖИМЫ (подпись входит в ключ), но слот
        // держат до вытеснения — потолок и есть их срок жизни.
        if (planCache.size >= PLAN_CACHE_MAX) {
            planCache.delete(planCache.keys().next().value);
        }
        planCache.set(key, entry);
    }

    /**
     * Обрыв летящего раскрытия. Зовётся и при закрытии панели: ответ, который
     * уже некому показать, всё равно занимает место в ведре 120/60 и держит
     * соединение.
     */
    function cancelPlanFlats() {
        if (!planInflight) return false;
        planInflight.abort();
        planInflight = null;
        return true;
    }

    /**
     * Квартиры ОДНОЙ планировки. Ходит в ТО ЖЕ ведро лимита (flat_list_jk_,
     * 120/60), что и выдача, поэтому повторное раскрытие той же карточки при том
     * же фильтре берётся из кэша и сети не касается.
     *
     * Гонка «клик ↔ смена фильтра»: подпись фильтра снимается в момент запроса и
     * сверяется при разборе ответа. Разошлась — отдаём null: человек уже смотрит
     * другой набор, показывать ему квартиры от прежнего нельзя.
     */
    function planFlats(sel) {
        const norm = normPlanSel(sel);
        if (norm === null) {
            return Promise.reject(filterError('bad plan selector', 'plan', 'bad_payload', false));
        }
        const base = getQuery();
        const sig = requestSig(base);
        const key = sig + '@@' + norm.rooms + '|' + norm.lo + '|' + norm.hi;
        // Предыдущее раскрытие больше не нужно: аккордеон — синглтон, его панель
        // уже закрыта кликом по этой карточке. Обрываем ДО ветки кэша: иначе
        // «медленная планировка → быстрая из кэша» оставляла бы висеть запрос,
        // который всё равно никто не покажет.
        cancelPlanFlats();
        const hit = planCache.get(key);
        if (hit) {
            return Promise.resolve({
                flats: clone(hit.flats), total: hit.total,
                catalogUrl: hit.catalogUrl, cached: true,
            });
        }
        const ctrl = new AbortController();
        ctrl.timedOut = false;
        planInflight = ctrl;
        const timeoutId = setTimeout(() => {
            ctrl.timedOut = true;
            ctrl.abort();
        }, REQUEST_TIMEOUT_MS);

        const q = planQuery(base, norm);
        // Ссылка «показать все» считается ЗДЕСЬ же: она обязана описывать тот
        // самый набор, который ушёл в запрос, а не живые контролы на момент,
        // когда человек до неё домотает.
        const planCatalogUrl = catalogUrlFor(q);

        return fetch(planListUrl(q), {
            credentials: 'same-origin',
            signal: ctrl.signal,
        })
            .then(r => {
                if (r.status === 429) throw filterError('rate limit', 'plan', 'rate_limit', true);
                if (!r.ok) throw filterError('HTTP ' + r.status, 'plan', 'network', r.status >= 500);
                return r.json();
            })
            .then(d => {
                if (!d || d.ok !== true || !Array.isArray(d.flats)) {
                    throw filterError('bad payload', 'plan', 'bad_payload', false);
                }
                // `total` — сколько квартир у планировки ВСЕГО под этим фильтром;
                // `flats` обрезаны страницей (100). На проде есть кластеры по 337
                // квартир, поэтому потребитель ОБЯЗАН показывать оба числа.
                const entry = {
                    flats: d.flats,
                    total: parseInt(d.total, 10) || d.flats.length,
                    catalogUrl: planCatalogUrl,
                };
                // Кладём в кэш ДО проверки актуальности: набор описывает свою
                // подпись честно, и если человек вернёт прежний фильтр, повтор
                // раскрытия уже не потратит запрос.
                planCacheStore(key, entry);
                if (requestSig(getQuery()) !== sig) return null;
                return {
                    flats: clone(entry.flats), total: entry.total,
                    catalogUrl: entry.catalogUrl, cached: false,
                };
            })
            .catch(e => {
                // Вытеснили новым кликом — не ошибка, просто ответ никому не нужен.
                if (e && e.name === 'AbortError' && !ctrl.timedOut) return null;
                if (ctrl.timedOut) throw filterError('timeout', 'plan', 'timeout', true);
                throw e && e.stage ? e : filterError(e && e.message, 'plan', 'network', true);
            })
            .finally(() => {
                clearTimeout(timeoutId);
                if (planInflight === ctrl) planInflight = null;
            });
    }

    // ═══ Счётчик «Найдено N» ═══
    /**
     * @param {?number} total количество квартир (null = посчитать не удалось)
     * @param {?number} plans количество карточек планировок; задан только в
     *        режиме планировок — тогда счётчик показывает ОБА числа, иначе
     *        «Найдено 12» рядом с 40 карточками читалось бы как ошибка.
     */
    function setCounter(total, plans) {
        dom.found.textContent = '';
        if (total === null) {
            dom.found.textContent = 'Не удалось посчитать';
            return;
        }
        if (total === 0) {
            dom.found.textContent = 'Ничего не найдено — измените фильтр';
            return;
        }
        const flatsText = ' ' + pluralRu(total, 'квартира', 'квартиры', 'квартир');
        const strong = document.createElement('strong');
        dom.found.appendChild(document.createTextNode('Найдено '));
        dom.found.appendChild(strong);
        if (isNum(plans) && plans > 0) {
            strong.textContent = fmtPrice(plans);
            dom.found.appendChild(document.createTextNode(
                ' ' + pluralRu(plans, 'планировка', 'планировки', 'планировок') +
                ' · ' + fmtPrice(total) + flatsText
            ));
            return;
        }
        strong.textContent = fmtPrice(total);
        dom.found.appendChild(document.createTextNode(flatsText));
    }

    function showError(msg, retryable) {
        if (!dom.error) return;
        dom.error.textContent = '';
        dom.error.classList.toggle('jk-hidden', msg === '');
        if (msg === '') return;
        const text = document.createElement('span');
        text.textContent = msg;
        dom.error.appendChild(text);
        if (retryable !== true) return;
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'jk-filter__retry';
        btn.textContent = 'Повторить';
        btn.addEventListener('click', retryFailed);
        dom.error.appendChild(btn);
    }

    // ═══ Рендер управления по фасетам ═══
    /**
     * Кнопки создаются ОДИН раз и дальше только меняют состояние. Пересборка
     * списка на каждый клик роняла фокус на body — клавиатурный пользователь
     * после выбора чипа начинал Tab заново с начала документа.
     */
    const chipsRegistry = { rooms: [], deadlines: [], renovation: [] };

    /**
     * Адреса соседних групп комнатности — С САМОЙ СТРАНИЦЫ, из полосы `.jkr-nav`
     * (`components/jk-rooms-nav.php`), а не склейкой в скрипте.
     *
     * ⛔ ВТОРОГО СБОРЩИКА АДРЕСА НЕ ЗАВОДИМ. Адреса ЖК собирает единственный класс
     * `JkUrl` (ADR-091): склей мы «/kvartiry/2-komnatnye/» здесь, ссылка разъехалась
     * бы с canonical в первый же день — например у подмосковных домов, где первый
     * сегмент витрины не совпадает с городом из базы (ADR-078).
     *
     * ⛔ ВЕРХНЯЯ ГРУППА («4 и больше») ПОМЕЧЕНА СЕРВЕРОМ (`data-rooms-min`), а не
     * вычислена здесь: правило «что такое верхняя группа» живёт в JkRoomsGroup, и
     * второе такое же в JS однажды разошлось бы с ним.
     *
     * @returns {{byRooms: Object, min: ?number}}
     */
    function readRoomsLinks() {
        const out = { byRooms: {}, min: null };
        const nav = document.querySelector('.jkr-nav');
        if (!nav) return out;
        nav.querySelectorAll('[data-bucket]').forEach((node) => {
            const bucket = parseInt(node.dataset.bucket, 10);
            if (!Number.isInteger(bucket) || bucket < 0) return;
            if (node.dataset.roomsMin !== undefined) out.min = bucket;
            // У активного звена адреса нет намеренно (ссылка на саму себя) — оно
            // остаётся выбранным чипом, а не ссылкой.
            const href = node.getAttribute('href');
            if (href) out.byRooms[bucket] = href;
        });
        return out;
    }

    const roomsLinks = readRoomsLinks();

    function chip(label, count, ymGoal) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'jk-filter__chip';
        btn.setAttribute('aria-pressed', 'false');
        btn.dataset.ym = ymGoal;
        const text = document.createElement('span');
        text.textContent = label;
        btn.appendChild(text);
        if (isNum(count) && count > 0) {
            const badge = document.createElement('span');
            badge.className = 'jk-filter__chip-count';
            badge.textContent = String(count);
            btn.appendChild(badge);
        }
        return btn;
    }

    /**
     * Чип комнатности НА СТРАНИЦЕ ГРУППЫ — ссылкой на соседнюю группу (ADR-125,
     * 28.08.2026).
     *
     * ⛔ ЧТО БЫЛО СЛОМАНО. На `…/kvartiry/4-komnatnye/` сервер приказывает
     * `rooms_min=4`, и клик по чипу «1» давал запрос `rooms_min=4 & rooms=1` — пустая
     * выдача и тупик: вернуться к своей группе нечем. На точных группах чип просто
     * уводил показ с темы страницы, оставляя заголовок про двухкомнатные.
     *
     * ⛔ ПОЧЕМУ ССЫЛКА, А НЕ ЗАПРЕТ. Соседняя группа — существующая страница со своим
     * заголовком, ценами и canonical; ссылка на неё это ещё и внутренняя перелинковка
     * (~570 страниц ищут входящие ссылки). Чип СВОЕЙ группы остаётся выбранной кнопкой
     * и заблокирован: нажимать нечего, мы уже здесь.
     */
    function roomsChipAsLink(btn, value) {
        const href = roomsLinks.byRooms[value];
        if (!href) return false;
        const link = document.createElement('a');
        link.className = btn.className;
        link.href = href;
        link.dataset.ym = 'jk_rooms_group';
        while (btn.firstChild) link.appendChild(btn.firstChild);
        return link;
    }

    function syncChips() {
        chipsRegistry.rooms.forEach(entry => {
            entry.btn.setAttribute('aria-pressed', state.rooms === entry.value ? 'true' : 'false');
        });
        chipsRegistry.deadlines.forEach(entry => {
            entry.btn.setAttribute('aria-pressed', state.deadlineIdx === entry.value ? 'true' : 'false');
        });
        chipsRegistry.renovation.forEach(entry => {
            entry.btn.setAttribute('aria-pressed', state.renovation === entry.value ? 'true' : 'false');
        });
    }

    /** Активен ли фильтр «не своей» группы — тогда счётчики чипов врут. */
    function activeKinds() {
        syncStateFromControls();
        return {
            rooms: state.rooms !== null,
            deadline: state.deadlineIdx !== null,
            renovation: state.renovation !== null,
            range: isNum(state.priceMin) || isNum(state.priceMax) ||
                   isNum(state.areaMin) || isNum(state.areaMax) ||
                   isNum(state.floorMin) || isNum(state.floorMax),
        };
    }

    /**
     * Счётчики фасетов посчитаны БЕЗ учёта других фильтров (матрицы
     * «комнатность × срок × цена» API не отдаёт). Как только включён фильтр
     * соседней группы — цифры на чипах перестают соответствовать выдаче,
     * поэтому прячем их, а не показываем заведомо неверные.
     */
    function syncCountVisibility() {
        const k = activeKinds();
        dom.rooms.classList.toggle('is-counts-stale', k.deadline || k.renovation || k.range);
        dom.deadlines.classList.toggle('is-counts-stale', k.rooms || k.renovation || k.range);
        if (dom.renovation) {
            dom.renovation.classList.toggle('is-counts-stale', k.rooms || k.deadline || k.range);
        }
    }

    function renderRooms(list) {
        dom.rooms.textContent = '';
        chipsRegistry.rooms = [];
        if (!Array.isArray(list) || list.length === 0) {
            dom.roomsGroup.classList.add('jk-hidden');
            return;
        }
        // ⛔ НА СТРАНИЦЕ ГРУППЫ ЧИПА «ВСЕ» НЕТ. Он означал бы «показать весь дом» под
        // заголовком «Купить 2-комнатную квартиру» — то есть выдачу не по теме
        // страницы. Все квартиры дома доступны ссылкой в полосе групп и в крошках.
        if (!roomsPinned()) {
            const all = chip('Все', null, 'jk_filter_rooms');
            all.addEventListener('click', () => pickRooms(null));
            dom.rooms.appendChild(all);
            chipsRegistry.rooms.push({ btn: all, value: null });
        }

        list.forEach(item => {
            // Мусорное значение из фида не должно тихо превращаться в rooms=NaN
            // (сервер прочитал бы его как 0 = «студии» и показал не то).
            const value = parseInt(item.value, 10);
            if (!Number.isInteger(value) || value < 0) return;
            const btn = chip(String(item.label || ''), parseInt(item.count, 10) || 0, 'jk_filter_rooms');
            if (roomsPinned()) {
                // Своя группа — выбранный и заблокированный чип; чужая — ссылка на её
                // страницу. Разбор в шапке roomsChipAsLink().
                if (ownRoomsBucket(value)) {
                    btn.disabled = true;
                    btn.setAttribute('aria-pressed', 'true');
                    btn.setAttribute('aria-current', 'page');
                    dom.rooms.appendChild(btn);
                    return;
                }
                const link = roomsChipAsLink(btn, value);
                if (link) {
                    dom.rooms.appendChild(link);
                    return;
                }
                // Ссылки на группу нет (дом без слага, полоса не напечаталась) — чип
                // не показываем вовсе: увести человека в пустую выдачу хуже, чем не
                // предложить перехода.
                return;
            }
            btn.addEventListener('click', () => {
                // Повторный клик по активному чипу = снять фильтр (API умеет
                // ровно одну комнатность за запрос, мультивыбора у rooms нет).
                pickRooms(state.rooms === value ? null : value);
            });
            dom.rooms.appendChild(btn);
            chipsRegistry.rooms.push({ btn: btn, value: value });
        });
        dom.roomsGroup.classList.remove('jk-hidden');
        syncChips();
    }

    /** Мы на странице группы? Признак один — приказ сервера (см. readRoomsPin). */
    function roomsPinned() {
        return roomsPin.rooms !== null || roomsPin.roomsMin !== null;
    }

    /**
     * Принадлежит ли комнатность ГРУППЕ ЭТОЙ СТРАНИЦЫ. У верхней группы («4 и больше»)
     * своих значений несколько: 4, 5, 6 — все они её, и уводить с них некуда.
     */
    function ownRoomsBucket(value) {
        if (roomsPin.roomsMin !== null) return value >= roomsPin.roomsMin;
        return roomsPin.rooms === value;
    }

    function pickRooms(value) {
        state.rooms = value;
        syncChips();
        onControlChange(CHIP_DEBOUNCE_MS);
    }

    /** Комнатность есть среди чипов ЖК? (в фасетах только РЕАЛЬНЫЕ значения). */
    function roomsAvailable(value) {
        return chipsRegistry.rooms.some(entry => entry.value === value);
    }

    /**
     * Чипы отделки: ровно те бакеты, что есть в ЖК, в порядке фасетов
     * («Без отделки» → «С отделкой»). Ключ бакета берём ИЗ ОТВЕТА, а подпись
     * печатаем как текст — сочинять её на клиенте нельзя, иначе кнопка и
     * серверный whitelist разъедутся при первом же добавлении бакета.
     *
     * ⛔ Одна-единственная группа отделки — не выбор, а сообщение: у ЖК, где вся
     * отделка одинаковая, чип «Без отделки · 701» ничего не отбирает (нажми —
     * найдётся ровно то же самое). Такой группы не показываем вовсе, тем же
     * правилом, что прячет вырожденный слайдер.
     */
    function renderRenovation(list) {
        if (!dom.renovation || !dom.renovationGroup) return;
        dom.renovation.textContent = '';
        chipsRegistry.renovation = [];
        const usable = (Array.isArray(list) ? list : []).filter(item =>
            item && RENOVATION_KEYS.indexOf(String(item.key)) >= 0
            && (parseInt(item.count, 10) || 0) > 0
        );
        if (usable.length < 2) {
            dom.renovationGroup.classList.add('jk-hidden');
            return;
        }

        const all = chip('Любая', null, 'jk_filter_renovation');
        all.addEventListener('click', () => pickRenovation(null));
        dom.renovation.appendChild(all);
        chipsRegistry.renovation.push({ btn: all, value: null });

        usable.forEach(item => {
            const key = String(item.key);
            const btn = chip(String(item.label || ''), parseInt(item.count, 10) || 0, 'jk_filter_renovation');
            btn.addEventListener('click', () => {
                // Повторный клик по активному чипу снимает фильтр: сервер умеет
                // ровно один бакет за запрос, мультивыбора у renovation нет.
                pickRenovation(state.renovation === key ? null : key);
            });
            dom.renovation.appendChild(btn);
            chipsRegistry.renovation.push({ btn: btn, value: key });
        });
        dom.renovationGroup.classList.remove('jk-hidden');
        syncChips();
    }

    function pickRenovation(key) {
        state.renovation = key;
        syncChips();
        onControlChange(CHIP_DEBOUNCE_MS);
    }

    /** Бакет отделки есть среди чипов ЖК? */
    function renovationAvailable(key) {
        return chipsRegistry.renovation.some(entry => entry.value === key);
    }

    /**
     * Набор фильтров ВИТРИНЫ (версия 8, только `data-on-showcase`): вкладка «Планировки»
     * витрины квартир дома отдаёт сюда фильтр и сортировку, с которыми витрина только что
     * просила плитку (js/flats.js → js/flats-plans-view.js). Тот же набор — та же выдача:
     * корпус с генплана, комнатность, цена, «Ещё фильтры» сужают планировки так же, как
     * плитку, и «Найдено» у вкладок одно.
     *
     * Набор не сменился — ничего не делаем: переключение «Плитка ↔ Планировки» туда и
     * обратно сети не касается. Сменился — выдача перезапрашивается сразу (витрина уже
     * выждала своё окно у полей ввода) либо берётся из кэша режима.
     *
     * @param {?Object} query фильтры витрины (имена параметров flat_api.php)
     * @param {?string} sort  сортировка витрины; неизвестная блоку — цена по возрастанию
     * @returns {boolean} сменился ли набор
     */
    function drive(query, sort) {
        if (!ON_SHOWCASE) return false;
        const before = requestSig(getQuery());
        driven = cleanDrive(query);
        state.sort = SORTS.indexOf(sort) >= 0 ? sort : DEFAULT_SORT;
        if (requestSig(getQuery()) === before) return false;
        state.page = 1;
        // До первого ответа фасетов выдачу не зовём: первый запрос (startLoad) уйдёт уже
        // с новым набором.
        if (!autoLoad || !facets) return true;
        const cached = cacheHit(state.mode);
        if (cached) emitCached(cached);
        else apply({ page: 1 });
        return true;
    }
    /**
     * Отделка ИЗВНЕ (версия 7). Ведёт себя как клик по чипу.
     *
     * ⛔ ПРИНИМАЕМ КЛЮЧ БАКЕТА, А НЕ ИНДЕКС И НЕ ПОДПИСЬ. Ключи — серверный
     * whitelist (RenovationBucket), он один на все витрины и не меняется; индекс
     * же зависит от того, какие бакеты есть у ЭТОГО дома («1» = «Черновая» у
     * одного и «Предчистовая» у другого), а подпись — просто текст кнопки, её
     * правка молча выключила бы применение ответа. Со сроком сдачи наоборот:
     * там стабильного ключа не существует вовсе, поэтому он ходит подписью.
     *
     * Бакета нет у ЖК — отвечаем false и НЕ трогаем состояние: молча выставить
     * «Черновая» там, где её нет, значит показать пустую выдачу без единого
     * нажатого чипа.
     *
     * @param {?string} key ключ бакета либо null = «Любая»
     * @returns {boolean} применено ли
     */
    function setRenovation(key) {
        if (key === null || key === undefined) {
            if (state.renovation === null) return false;
            pickRenovation(null);
            return true;
        }
        const want = String(key);
        if (RENOVATION_KEYS.indexOf(want) < 0 || !renovationAvailable(want)) return false;
        if (state.renovation === want) return false;
        pickRenovation(want);
        return true;
    }

    /**
     * Публичная установка комнатности (1.7.4) — для сценариев «выбрать за
     * человека» из другого кода страницы. Ведёт себя как клик по чипу: правит
     * состояние и перезапрашивает выдачу через общий debounce.
     *
     * Значение вне фасетов игнорируем: молча выставленный rooms=4 у ЖК без
     * четырёхкомнатных дал бы человеку пустую выдачу и ни одного нажатого чипа —
     * выглядит как поломка.
     *
     * ⚠️ Легаси-якорь `#room-*` сюда НЕ ходит: ему нужна установка ДО первого
     * запроса, без второго похода в сеть — это `primeRooms()` ниже.
     *
     * @param {number|null} value комнатность (0 = студия) либо null = «Все»
     * @returns {boolean} применено ли
     */
    function setRooms(value) {
        if (value === null) {
            if (state.rooms === null) return false;
            pickRooms(null);
            return true;
        }
        const n = parseInt(value, 10);
        if (!Number.isInteger(n) || n < 0 || !roomsAvailable(n)) return false;
        if (state.rooms === n) return false;
        pickRooms(n);
        return true;
    }

    /**
     * Цена ИЗВНЕ (версия 6). Ведёт себя как ручной ввод в поля «от-до»: значение
     * видно на слайдере и в полях, запрос уходит через тот же debounce.
     *
     * ⛔ ИМЕННО ЧЕРЕЗ КОНТРОЛ, А НЕ МИМО НЕГО. Записать цену прямо в `state`
     * было бы тише и короче — и разошлось бы с экраном: syncStateFromControls()
     * на следующем же чтении вернул бы значения ПОЛЕЙ, затерев записанное.
     * Ровно поэтому у выдачи и не получалось применить бюджет до версии 6.
     *
     * @param {?number} min рублей (null = нижняя граница дома)
     * @param {?number} max рублей (null = верхняя граница дома)
     * @returns {boolean} изменилось ли что-нибудь
     */
    function setPrice(min, max) {
        if (!priceRange || !priceRange.setValues(min, max)) return false;
        onControlChange(CHIP_DEBOUNCE_MS);
        return true;
    }

    /**
     * Этаж ИЗВНЕ (версия 6). Тот же путь, что у цены.
     * ⛔ У ЖК без этажности (или с домом в один этаж) диапазон вырожден и скрыт —
     *    setValues вернёт false, и фильтр не притворится, что отобрал по этажу.
     *
     * @param {?number} min этаж «от»
     * @param {?number} max этаж «до»
     * @returns {boolean} изменилось ли что-нибудь
     */
    function setFloor(min, max) {
        if (!floorRange || !floorRange.setValues(min, max)) return false;
        onControlChange(CHIP_DEBOUNCE_MS);
        return true;
    }

    /**
     * Срок сдачи ИЗВНЕ (версия 6) — ПО ПОДПИСИ, а не по индексу.
     *
     * ⛔ ИНДЕКС НАРУЖУ НЕ ОТДАЁМ. Внутри плашки живут позицией в
     * `facets.deadlines`, но у каждого ЖК свой набор сроков и свой их порядок:
     * «2» это «Сдан 2024» у одного дома и «Строится · 3 кв. 2027» у другого.
     * Потребитель, запомнивший индекс, отфильтровал бы по чужому сроку и не
     * заметил бы этого. Подпись — то же самое, что человек читает на плашке.
     *
     * ⛔ Работает только там, где плашки ВЫБИРАЮТСЯ. При sections_supported=false
     * срок один на всё здание и печатается фактом, а не кнопкой (renderDeadlines):
     * реестр плашек пуст, и мы честно возвращаем false, а не меняем состояние,
     * которого не видно на экране.
     *
     * @param {?string} label подпись плашки либо null = «Любой»
     * @returns {boolean} применено ли
     */
    function setDeadline(label) {
        if (label === null || label === undefined) {
            if (state.deadlineIdx === null) return false;
            pickDeadline(null);
            return true;
        }
        if (chipsRegistry.deadlines.length === 0 || !facets || !Array.isArray(facets.deadlines)) {
            return false;
        }
        const want = String(label);
        let idx = null;
        facets.deadlines.forEach((item, i) => {
            if (idx === null && String(item.label || '') === want) idx = i;
        });
        // Плашки с такой подписью у ЖК нет — молча отфильтровать «по ничему»
        // хуже, чем отказать: вызывающий увидит false и не соврёт человеку.
        if (idx === null) return false;
        // Реестр плашек и facets.deadlines заполняются одним проходом
        // renderDeadlines, но проверяем явно: «Любой» занимает нулевую позицию
        // реестра, поэтому длины у них не совпадают by design.
        if (!chipsRegistry.deadlines.some(entry => entry.value === idx)) return false;
        if (state.deadlineIdx === idx) return false;
        pickDeadline(idx);
        return true;
    }

    /**
     * То же, но БЕЗ запроса: состояние правится до первой загрузки выдачи.
     * Нужен легаси-якорю (ниже): фасеты только что приехали, и стартовый
     * apply() ещё впереди — планировать второй запрос было бы дублем.
     */
    function primeRooms(value) {
        if (!Number.isInteger(value) || value < 0 || !roomsAvailable(value)) return false;
        state.rooms = value;
        syncChips();
        syncCountVisibility();
        return true;
    }

    function pickDeadline(idx) {
        state.deadlineIdx = idx;
        syncChips();
        onControlChange(CHIP_DEBOUNCE_MS);
    }

    /**
     * Список корпусов ВЫПАДАЮЩИМ списком: у ЖК «Самолет» их 66, и плашками
     * фильтр занял бы пол-экрана (слово владельца 22.09.2026 — «покомпактнее»).
     * ⛔ Корпуса берутся из тех же плашек срока, что уже приехали с сервера:
     * своего запроса не заводим, второй источник разошёлся бы с первым.
     */
    function renderSections(list, supported) {
        if (!dom.sections || !dom.sectionsGroup) return;
        const names = [];
        if (supported && Array.isArray(list)) {
            list.forEach(item => {
                if (!Array.isArray(item.sections)) return;
                item.sections.forEach(name => {
                    if (typeof name === 'string' && name !== '' && !names.includes(name)) names.push(name);
                });
            });
        }
        // Один корпус фильтровать нечем: выбор ничего не изменит.
        if (names.length < 2) {
            dom.sectionsGroup.classList.add('jk-hidden');
            return;
        }
        names.sort((a, b) => {
            const na = parseInt(a.replace(/\D+/g, ''), 10);
            const nb = parseInt(b.replace(/\D+/g, ''), 10);
            if (!isNaN(na) && !isNaN(nb) && na !== nb) return na - nb;
            return a.localeCompare(b, 'ru');
        });
        dom.sections.textContent = '';
        const any = document.createElement('option');
        any.value = '';
        any.textContent = 'Любой';
        dom.sections.appendChild(any);
        names.forEach(name => {
            const option = document.createElement('option');
            option.value = name;
            option.textContent = /^\d+$/.test(name) ? 'Корпус ' + name : name;
            dom.sections.appendChild(option);
        });
        syncSectionsPicker();
        dom.sectionsGroup.classList.remove('jk-hidden');
    }

    // Генплан выбирает физический дом сразу по нескольким именам фида.
    // Поле показывает тот же полный набор, который уже отправляется в запросе.
    function syncSectionsPicker() {
        if (!dom.sections) return;
        dom.sections.querySelectorAll('[data-genplan-sections]').forEach(option => option.remove());
        const section = state.section || '';
        if (section.includes('|')) {
            const combined = document.createElement('option');
            combined.value = section;
            combined.textContent = section.split('|').join(', ');
            combined.dataset.genplanSections = '';
            dom.sections.appendChild(combined);
        }
        dom.sections.value = section;
    }

    function renderDeadlines(list, supported) {
        dom.deadlines.textContent = '';
        chipsRegistry.deadlines = [];
        // 18 из 118 ЖК на проде не дают ни одной плашки — блок сроков в таком
        // случае не рисуем вовсе (пустая строка «Срок сдачи» выглядит поломкой).
        if (!Array.isArray(list) || list.length === 0) {
            dom.deadlinesGroup.classList.add('jk-hidden');
            return;
        }
        dom.deadlinesGroup.classList.remove('jk-hidden');

        // Без разбивки по корпусам срок один на весь ЖК — фильтровать нечего,
        // показываем фактом, а не кнопкой (клик ничего бы не менял).
        if (!supported) {
            list.forEach(item => {
                const note = document.createElement('span');
                note.className = 'jk-filter__note';
                const icon = document.createElement('i');
                icon.className = 'fas fa-calendar-check';
                icon.setAttribute('aria-hidden', 'true');
                const text = document.createElement('span');
                text.textContent = window.BuildStatus.deadlineLine(item.label);
                note.appendChild(icon);
                note.appendChild(text);
                dom.deadlines.appendChild(note);
            });
            return;
        }

        const all = chip('Любой', null, 'jk_filter_deadline');
        all.addEventListener('click', () => pickDeadline(null));
        dom.deadlines.appendChild(all);
        chipsRegistry.deadlines.push({ btn: all, value: null });

        list.forEach((item, idx) => {
            const btn = chip(String(item.label || ''), parseInt(item.count, 10) || 0, 'jk_filter_deadline');
            btn.addEventListener('click', () => {
                pickDeadline(state.deadlineIdx === idx ? null : idx);
            });
            dom.deadlines.appendChild(btn);
            chipsRegistry.deadlines.push({ btn: btn, value: idx });
        });
        syncChips();
    }

    function applyFacets(data) {
        facets = data;
        renderRooms(data.rooms);
        renderDeadlines(data.deadlines, data.sections_supported === true);
        renderSections(data.deadlines, data.sections_supported === true);
        // Старый ответ фасетов (тёплый кэш v2 у человека в прокси) поля
        // `renovation` не содержит — тогда группа просто не появится, а не
        // нарисуется пустой строкой.
        renderRenovation(data.renovation);

        const area = data.area || {};
        const price = data.price || {};
        if (areaRange) {
            // EPS: 88.7*10 в IEEE-754 бывает 887.0000000000001 — без допуска
            // граница слайдера уезжала бы на 88.8 и «до максимума» переставало
            // быть дефолтом (фильтр area_max уходил бы в каждый запрос).
            const eps = 1e-9;
            areaRange.setBounds(
                Math.floor((parseFloat(area.min) || 0) * 10 + eps) / 10,
                Math.ceil((parseFloat(area.max) || 0) * 10 - eps) / 10
            );
        }
        if (priceRange) {
            const lo = parseInt(price.min, 10) || 0;
            const hi = parseInt(price.max, 10) || 0;
            priceRange.setBounds(
                Math.floor(lo / PRICE_STEP) * PRICE_STEP,
                Math.ceil(hi / PRICE_STEP) * PRICE_STEP
            );
        }
        if (floorRange) {
            // Старый ответ фасетов (тёплый кэш v1 у человека в прокси / свой
            // jk-filter.js новее сервера) поля `floor` не содержит — тогда
            // границы 0..0, диапазон вырожденный, блок остаётся скрытым.
            const floor = data.floor || {};
            floorRange.setBounds(parseInt(floor.min, 10) || 0, parseInt(floor.max, 10) || 0);
        }
        // Легаси-якорь — ОДИН раз и только до первой выдачи: дальше комнатностью
        // распоряжается человек, и повторная загрузка фасетов (ретрай) не должна
        // возвращать чип, который он уже снял.
        if (roomAnchor !== null) {
            if (primeRooms(roomAnchor)) forgetRoomAnchor();
            roomAnchor = null;
        }
        setCounter(parseInt(data.total, 10) || 0);
        syncCountVisibility();
        // 1.7.4: `jk-filter--ssr` — стартовое состояние панели, отрисованной ради
        // SSR-таблицы планировок (управление в ней спрятано). Фасеты приехали,
        // управлять есть чем — снимаем оба класса разом.
        root.classList.remove('jk-hidden', 'jk-filter--ssr');
        facetsState = 'ready';
        emit('facets', clone(facets));
    }

    /**
     * Терминальный ответ «фильтра не будет»: подписчики onFacets получают null,
     * onError — причину. Без этого 1.3 не мог отличить «ещё грузим» от «нечего
     * показывать» и висел бы со скелетоном вечно.
     */
    function facetsGiveUp(reason, message) {
        facetsState = reason === 'empty' || reason === 'not_found' ? 'empty' : 'error';
        emit('facets', null);
        emit('error', filterError(message, 'facets', reason, false));
    }

    /**
     * ⛔ ОДИН ЗАПРОС ФАСЕТОВ ДОМА НА СТРАНИЦУ (проверка 27.09.2026, P2-2). На витрине квартир
     * дома тот же адрес `jk_facets` спрашивает шапка (js/jk-flats-hero.js) на загрузке, а этот
     * блок — когда открыли вкладку «Планировки»: второй запрос за тем же ответом был бы лишним
     * ожиданием. Кто первый — тот и спрашивает; ответ разобран один раз и лежит обещанием в `window.BRONI_JK_FACETS[адрес]`.
     * Форма ответа `{ok, status, data}` — ОДНА И ТА ЖЕ в обоих файлах (сверяет
     * tests/JS/jk-filter-results.test.js): `data` разбирается только у ответа 2xx, сбой
     * разбора — отказ обещания, как было у `r.json()`.
     */
    function sharedFacets(url, fresh) {
        const box = window.BRONI_JK_FACETS || (window.BRONI_JK_FACETS = {});
        if (fresh || !box[url]) {
            box[url] = fetch(url, { credentials: 'same-origin' }).then(r => (r.ok
                ? r.json().then(data => ({ ok: true, status: r.status, data: data }))
                : { ok: false, status: r.status, data: null }));
        }
        return box[url];
    }

    function loadFacets(isRetry) {
        // Повторное появление секции в кадре не должно плодить параллельные
        // запросы и не должно перебивать уже назначенный отложенный ретрай.
        if (facetsInflight || facetsState === 'ready') return Promise.resolve();
        if (facetsRetryPending && !isRetry) return Promise.resolve();
        facetsInflight = true;
        facetsState = 'loading';
        // Повторная попытка — всегда свежий запрос: общий ответ в этот момент заведомо сбойный.
        return sharedFacets(
            API_URL + '?action=jk_facets&building_id=' + encodeURIComponent(String(buildingId)),
            isRetry
        )
            .then(res => {
                // 4xx — приговор (скрытый / несуществующий ЖК), ретрай бессмыслен.
                // 5xx и сеть — повод для ОДНОЙ отложенной попытки.
                if (!res.ok) {
                    throw filterError('HTTP ' + res.status, 'facets',
                        res.status >= 500 ? 'network' : 'not_found', res.status >= 500);
                }
                return res.data;
            })
            .then(d => {
                if (!d || d.ok !== true) {
                    facetsGiveUp('not_found', 'ЖК не найден или скрыт');
                    return;
                }
                if ((parseInt(d.total, 10) || 0) <= 0) {
                    // Квартир в продаже нет — фильтр не показываем, но молчать
                    // нельзя: 1.3 обязан знать, что ждать нечего.
                    facetsGiveUp('empty', 'В этом ЖК нет квартир в продаже');
                    return;
                }
                applyFacets(d);
            })
            .catch(e => {
                const retryable = !e || e.retryable !== false;
                if (retryable && !isRetry) {
                    facetsState = 'idle';
                    facetsRetryPending = true;
                    setTimeout(() => {
                        facetsRetryPending = false;
                        loadFacets(true);
                    }, FACETS_RETRY_MS);
                    return;
                }
                facetsGiveUp(
                    retryable ? 'network' : 'not_found',
                    'Не удалось загрузить параметры фильтра'
                );
            })
            .finally(() => {
                facetsInflight = false;
            });
    }

    // ═══ Сброс ═══
    function resetAll() {
        state.rooms = null;
        state.deadlineIdx = null;
        state.section = null;
        state.sectionNumbers = '';
        syncSectionsPicker();
        state.renovation = null;
        state.sort = DEFAULT_SORT;
        state.page = 1;
        if (dom.sort) dom.sort.value = DEFAULT_SORT;
        if (areaRange) areaRange.reset();
        if (priceRange) priceRange.reset();
        if (floorRange) floorRange.reset();
        syncChips();
        if (facets) setCounter(parseInt(facets.total, 10) || 0);
        syncCountVisibility();
        if (autoLoad) schedule(CHIP_DEBOUNCE_MS);
    }

    /**
     * Компактный генплан на странице (с корпусами, `data-genplan-compact`): страница
     * группы комнатности и — с 26.09.2026 — карточка ЖК (слово владельца: «пусть генплан
     * на странице ЖК будет так же, как на странице комнатности»). Генплан стоит на
     * странице раньше этого скрипта, поэтому признак читается сразу.
     */
    // ⛔ Генплан ведёт ЭТОТ блок, только если сужает именно его (`data-genplan-results`
    // указывает на #jkFlats). На витрине квартир дома (26.09.2026) тот же блок стоит над
    // сеткой квартир, а генплан сужает СЕТКУ — её отбор живёт в адресе (`?sections=`,
    // «Назад»), и второй отбор здесь по «Назад» не снимался бы.
    function genplanTargetsThisBlock() {
        const plan = document.querySelector('[data-genplan-compact]');
        if (!plan) return false;
        const own = document.getElementById('jkFlats');
        let target = null;
        try {
            target = plan.dataset.genplanResults ? document.querySelector(plan.dataset.genplanResults) : null;
        } catch (e) {
            target = null;
        }
        return Boolean(own && target && (target === own || target.contains(own) || own.contains(target)));
    }
    const genplanDrivesFilter = roomsPinned() || genplanTargetsThisBlock();

    if (dom.reset) {
        dom.reset.dataset.ym = 'jk_filter_reset';
        dom.reset.addEventListener('click', resetAll);
        // Страница группы и карточка ЖК с компактным генпланом: «Сбросить» снимает и
        // корпус на генплане.
        if (genplanDrivesFilter) dom.reset.addEventListener('click', () => document.dispatchEvent(new CustomEvent('broni:flats-filters-reset')));
    }

    /**
     * КОРПУС С ГЕНПЛАНА СУЖАЕТ ЭТОТ ЖЕ ФИЛЬТР — страница группы (слово владельца
     * 25.09.2026: сетку планировок над фильтром убрали, главным стал этот блок) и карточка
     * ЖК (26.09.2026: генплан карточки — тот же компактный, что на странице группы).
     * Компактный генплан шлёт `broni:genplan-corpus` с секцией из серверной ссылки
     * корпуса; ставим её тем же путём, что выбор корпуса в поле (state.section → запрос с
     * `sections`). Пустая секция — отбор снят. Корпуса нет среди корпусов этой выдачи —
     * отвечаем генплану `matched = 0`: он пишет «В этом корпусе нет …» и страницу не двигает.
     * Строка «1-комнатные · от …» в подсказке корпуса шлёт ещё и комнатность (`rooms`):
     * на карточке она ставится вместе с корпусом, как чип «1к»; на странице группы
     * комнатность прибита адресом, и генплан её там не шлёт.
     * ⛔ Карточка без схемы с обводкой (полный вид) событий не шлёт — слушать нечего.
     */
    if (genplanDrivesFilter) {
        document.addEventListener('broni:genplan-corpus', (event) => {
            const detail = event.detail || {};
            const { section, sectionNumbers } = window.broniGenplanCorpusFilter(detail);
            const listed = dom.sections && dom.sectionsGroup && !dom.sectionsGroup.classList.contains('jk-hidden')
                ? Array.from(dom.sections.options).map(option => option.value).filter(Boolean)
                : null;
            if (section !== '' && listed !== null && !section.split('|').some(value => listed.includes(value))) {
                detail.matched = 0;
                return;
            }
            // Страница группы: в поле «Корпус» — корпуса ВСЕГО ЖК, а не только с квартирами
            // этой группы. Корпус без неё (студий у «Корпуса 4.1» нет) уводил страницу к
            // «Ничего не найдено» под строкой генплана «Показаны квартиры» (стенд 28.09.2026).
            // Комнатности корпуса генплан знает (`roomTypes`, те же данные, что у витрины в
            // js/flats.js) — отвечаем «ноль»: он пишет «В этом корпусе нет студий», страница
            // стоит на месте, отбор списка не трогаем.
            if (section !== '' && roomsPinned() && Array.isArray(detail.roomTypes) && detail.roomTypes.length
                && !detail.roomTypes.some(value => ownRoomsBucket(Number(value)))) {
                detail.matched = 0;
                return;
            }
            state.section = section === '' ? null : section;
            state.sectionNumbers = sectionNumbers;
            syncSectionsPicker();
            if (!roomsPinned() && section !== '' && Number.isInteger(detail.rooms)
                && detail.rooms >= 0 && roomsAvailable(detail.rooms)) {
                state.rooms = detail.rooms;
                syncChips();
            }
            state.page = 1;
            onControlChange(CHIP_DEBOUNCE_MS);
        });
    }

    if (dom.sections) {
        dom.sections.dataset.ym = 'jk_filter_section';
        dom.sections.addEventListener('change', () => {
            const value = String(dom.sections.value || '');
            state.section = value === '' ? null : value;
            state.sectionNumbers = '';
            syncSectionsPicker();
            state.page = 1;
            onControlChange(CHIP_DEBOUNCE_MS);
        });
    }

    if (dom.sort) {
        dom.sort.dataset.ym = 'jk_filter_sort';
        dom.sort.addEventListener('change', () => {
            const v = String(dom.sort.value || '');
            state.sort = SORTS.indexOf(v) >= 0 ? v : DEFAULT_SORT;
            onControlChange(CHIP_DEBOUNCE_MS);
        });
    }

    function snapshot() {
        syncStateFromControls();
        return {
            rooms: state.rooms,
            deadline: clone(pickDeadlineFacet()),
            // Ключ бакета — то же, что уходит в запрос. Потребитель (выдача)
            // читает состояние фильтра ИЗ СЛЕПКА, поэтому пропуск поля здесь
            // означал бы, что отделка «не считается применённой» (см.
            // filterIsWideOpen в jk-filter-results.js).
            renovation: state.renovation,
            areaMin: state.areaMin,
            areaMax: state.areaMax,
            priceMin: state.priceMin,
            priceMax: state.priceMax,
            floorMin: state.floorMin,
            floorMax: state.floorMax,
            sort: state.sort,
            mode: state.mode,
            page: state.page,
        };
    }

    // ═══ Публичный контракт (потребитель — блок 1.3) ═══
    window.BroniJkFilter = {
        // 2 — режимы выдачи (setResultMode / resultMode / payload.mode).
        // 3 — раскрытие квартир планировки (fetchPlanFlats).
        // 4 — дефолт выдачи 'plans' как SSOT (defaultMode) + setRooms извне.
        // 5 — фильтр этажа: floorMin/floorMax в снимке состояния и
        //     floor_min/floor_max в getQuery()/catalogUrl().
        // 6 — сеттеры цены/этажа/срока извне (setPrice/setFloor/setDeadline).
        //     ⛔ Число прибито тестом (jk-filter-quiz.test.js): без пина
        //     следующая правка молча вернула бы 5, а потребитель, который
        //     проверяет версию перед вызовом, так же молча перестал бы
        //     применять три из пяти ответов опросника.
        // 7 — отделка: чипы `renovation` в панели, `renovation` в getQuery()/
        //     catalogUrl() и в снимке состояния, сеттер setRenovation(key).
        // 8 — ведомый режим вкладки «Планировки» витрины квартир дома: drive(query, sort).
        version: 8,
        buildingId: buildingId,
        city: city,
        resultsEl: dom.results,
        get facets() { return clone(facets); },
        get lastResult() { return clone(lastResult); },
        get facetsState() { return facetsState; },
        get resultMode() { return state.mode; },
        // SSOT дефолтного режима (1.7.4). Вид выдачи обязан брать стартовое
        // состояние ОТСЮДА, а не хранить свою копию: два дефолта = первый запрос
        // за одним набором данных и экран под другой.
        defaultMode: DEFAULT_MODE,
        // Режим, ЯВНО заданный адресом страницы, или null. Потребитель вида
        // обязан подчиниться ему в ОБЕ стороны: ?fv=flats у человека с
        // сохранёнными «Планировками» открывает именно квартиры.
        urlMode: urlMode,
        onResults(fn) {
            if (typeof fn !== 'function') return;
            listeners.results.push(fn);
            // Первый потребитель включает автозагрузку: до него запрос выдачи
            // не нужен (счётчик берётся из фасетов), после — обязателен.
            if (!autoLoad) {
                autoLoad = true;
                if (facets) apply({ page: 1 });
                return;
            }
            // Поздняя подписка (ответ уже пришёл) — отдаём последний результат
            // сразу, иначе такой подписчик не получил бы НИЧЕГО никогда.
            if (lastResult) {
                const replay = clone(lastResult);
                replay.append = false;
                try {
                    fn(replay);
                } catch (e) {
                    console.warn('jk-filter listener error:', e && e.message);
                }
            }
        },
        onLoading(fn) { if (typeof fn === 'function') listeners.loading.push(fn); },
        onError(fn) { if (typeof fn === 'function') listeners.error.push(fn); },
        onFacets(fn) {
            if (typeof fn !== 'function') return;
            listeners.facets.push(fn);
            // Replay: 'ready' → фасеты, терминальный отказ → null. В 'loading'
            // и 'idle' молчим — ответ придёт событием.
            if (facetsState === 'ready') fn(clone(facets));
            else if (facetsState === 'empty' || facetsState === 'error') fn(null);
        },
        apply: apply,
        loadMore: loadMore,
        fetchPlanFlats: planFlats,
        cancelPlanFlats: cancelPlanFlats,
        currentSig: () => requestSig(getQuery()),
        setResultMode: setResultMode,
        setRooms: setRooms,
        setPrice: setPrice,
        setFloor: setFloor,
        setDeadline: setDeadline,
        setRenovation: setRenovation,
        drive: drive,
        reset: resetAll,
        getState: snapshot,
        getQuery: getQuery,
        catalogUrl: catalogUrl,
    };

    // ═══ Старт: фасеты подгружаем при подходе к секции ═══
    function startLoad() {
        return loadFacets(false).then(() => {
            if (autoLoad && facets) apply({ page: 1 });
        });
    }

    const section = document.getElementById('jkFlats');
    /**
     * Легаси-якорь вёл на узел снесённого аккордеона — сейчас такого id в
     * документе нет, и браузер оставил бы человека наверху страницы. Доводим его
     * до секции квартир сами: заодно это включает загрузку фасетов через
     * наблюдатель ниже, без отдельной ветки старта.
     *
     * Скроллим ПОСЛЕ load и ещё через кадр: скрипт исполняется отложенно, но
     * hero-рендер и галерея к этому моменту ещё без размеров, и на мобиле прыжок
     * уезжал мимо секции — она доезжала до нужного места уже после нас.
     */
    function scrollToFlats() {
        if (!section || typeof section.scrollIntoView !== 'function') return;
        const reduced = window.matchMedia
            && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const go = () => section.scrollIntoView({
            behavior: reduced ? 'auto' : 'smooth',
            block: 'start',
        });
        const afterFrame = () => (typeof window.requestAnimationFrame === 'function'
            ? window.requestAnimationFrame(go)
            : go());
        if (document.readyState === 'complete') afterFrame();
        else window.addEventListener('load', afterFrame, { once: true });
    }
    // Легаси-якорь карточки ЖК. На странице группы прокрутку после отрисовки
    // планировок ведёт jk-rooms-scroll.js (слово владельца 02.10.2026).
    if (roomsPin.rooms === null && roomAnchor !== null) scrollToFlats();
    // ⛔ ВКЛАДКА «ПЛАНИРОВКИ» ВИТРИНЫ КВАРТИР ДОМА (27.09.2026, `data-on-showcase`): блок приходит
    // по нажатию на вкладку и встаёт на место сетки — человек уже смотрит на него, ждать, пока он
    // «подойдёт к экрану», нечего. Грузим сразу.
    // Группу грузим сразу: ожидание видимости создало бы цикл — карточек ещё нет,
    // jk-rooms-scroll.js ждёт их появления, а загрузка ждёт прокрутки к секции.
    if (ON_SHOWCASE || (roomsPinned() && root.closest('.jkr-flats'))) {
        startLoad();
    } else if (section && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver(entries => {
            if (!entries.some(en => en.isIntersecting)) return;
            // disconnect ТОЛЬКО после успеха: если первая попытка провалилась,
            // повторное появление секции в кадре — законный второй шанс.
            startLoad().then(() => {
                if (facetsState !== 'loading' && facetsState !== 'idle') io.disconnect();
            });
        }, { rootMargin: '400px 0px' });
        io.observe(section);
    } else {
        startLoad();
    }
})();
